var map = {
	"./accelerators/app-banners/1-banner.png": 13992,
	"./accelerators/app-banners/2-banner.png": 32873,
	"./accelerators/app-banners/3-banner.png": 65925,
	"./accelerators/app-banners/35-banner.png": 93711,
	"./accelerators/app-banners/4-banner.gif": 50447,
	"./accelerators/app-banners/5-banner.gif": 41962,
	"./accelerators/app-banners/6-banner.png": 14289,
	"./accelerators/app-banners/8-banner.png": 34626,
	"./accelerators/app-banners/9-banner.png": 26764,
	"./accelerators/app-icons/1-icon.svg": 20794,
	"./accelerators/app-icons/10-icon.svg": 18117,
	"./accelerators/app-icons/11-icon.svg": 20430,
	"./accelerators/app-icons/12-icon.svg": 54360,
	"./accelerators/app-icons/13-icon.svg": 59461,
	"./accelerators/app-icons/14-icon.svg": 66858,
	"./accelerators/app-icons/15-icon.svg": 77765,
	"./accelerators/app-icons/16-icon.svg": 2283,
	"./accelerators/app-icons/17-icon.svg": 6215,
	"./accelerators/app-icons/18-icon.svg": 62548,
	"./accelerators/app-icons/19-icon.svg": 90591,
	"./accelerators/app-icons/2-icon.svg": 73413,
	"./accelerators/app-icons/20-icon.svg": 88247,
	"./accelerators/app-icons/21-icon.svg": 43114,
	"./accelerators/app-icons/22-icon.svg": 98618,
	"./accelerators/app-icons/23-icon.svg": 19971,
	"./accelerators/app-icons/24-icon.svg": 52574,
	"./accelerators/app-icons/25-icon.svg": 4141,
	"./accelerators/app-icons/26-icon.svg": 80162,
	"./accelerators/app-icons/27-icon.svg": 63895,
	"./accelerators/app-icons/28-icon.svg": 62789,
	"./accelerators/app-icons/29-icon.svg": 75029,
	"./accelerators/app-icons/3-icon.svg": 39349,
	"./accelerators/app-icons/30-icon.svg": 87736,
	"./accelerators/app-icons/31-icon.svg": 48432,
	"./accelerators/app-icons/32-icon.svg": 16350,
	"./accelerators/app-icons/33-icon.svg": 96821,
	"./accelerators/app-icons/34-icon.svg": 17955,
	"./accelerators/app-icons/35-icon.svg": 80365,
	"./accelerators/app-icons/36-icon.svg": 15638,
	"./accelerators/app-icons/37-icon.svg": 5470,
	"./accelerators/app-icons/38-icon.svg": 46225,
	"./accelerators/app-icons/39-icon.svg": 16902,
	"./accelerators/app-icons/4-icon.svg": 26132,
	"./accelerators/app-icons/40-icon.svg": 37389,
	"./accelerators/app-icons/41-icon.svg": 1189,
	"./accelerators/app-icons/42-icon.svg": 64354,
	"./accelerators/app-icons/43-icon.svg": 53198,
	"./accelerators/app-icons/44-icon.svg": 40298,
	"./accelerators/app-icons/45-icon.svg": 46254,
	"./accelerators/app-icons/46-icon.svg": 23441,
	"./accelerators/app-icons/47-icon.svg": 69835,
	"./accelerators/app-icons/48-icon.svg": 76042,
	"./accelerators/app-icons/49-icon.svg": 1269,
	"./accelerators/app-icons/5-icon.svg": 31537,
	"./accelerators/app-icons/50-icon.svg": 91262,
	"./accelerators/app-icons/6-icon.svg": 30939,
	"./accelerators/app-icons/7-icon.svg": 21968,
	"./accelerators/app-icons/8-icon.svg": 37188,
	"./accelerators/app-icons/9-icon.svg": 36977,
	"./accelerators/app-icons/boat-icon.svg": 28855,
	"./application-notes/low-power-design/ADP1606.png": 90497,
	"./application-notes/low-power-design/AP2138.png": 78413,
	"./application-notes/low-power-design/AP2139.png": 36667,
	"./application-notes/low-power-design/BuckBoost.svg": 16608,
	"./application-notes/low-power-design/MAX17225.png": 67683,
	"./application-notes/low-power-design/SingleDryCell.svg": 96595,
	"./application-notes/low-power-design/TPS61021A.png": 54299,
	"./application-notes/low-power-design/USBtoNotecardM2.png": 12900,
	"./application-notes/low-power-design/dfu-enable.png": 35226,
	"./application-notes/low-power-design/logiclevelshifter.svg": 42666,
	"./application-notes/low-power-design/power-supply.png": 53303,
	"./application-notes/low-power-design/typical-application.png": 12418,
	"./blog/authors/christina-gorton.jpeg": 55311,
	"./blog/authors/david-scheltema.jpg": 1650,
	"./blog/authors/david-tischler.jpg": 32261,
	"./blog/authors/hayden-roche.jpeg": 63400,
	"./blog/authors/kimball-johnson.jpg": 53581,
	"./blog/authors/pradeep.jpg": 85116,
	"./blog/authors/prasannaa-kumar.jpg": 54752,
	"./blog/authors/rob-lauer.jpg": 99648,
	"./blog/authors/salman-faris.jpeg": 97550,
	"./blog/authors/tj-vantoll.jpg": 17603,
	"./blog/left-quote.svg": 87395,
	"./blog/posts/10-examples-to-help-you-learn-jsonata/banner.png": 10071,
	"./blog/posts/10-examples-to-help-you-learn-jsonata/example-1.1.png": 13442,
	"./blog/posts/10-examples-to-help-you-learn-jsonata/example-1.2.png": 56406,
	"./blog/posts/10-examples-to-help-you-learn-jsonata/example-2.png": 24957,
	"./blog/posts/10-examples-to-help-you-learn-jsonata/example-3.png": 73540,
	"./blog/posts/10-examples-to-help-you-learn-jsonata/example-4.png": 75502,
	"./blog/posts/10-examples-to-help-you-learn-jsonata/example-5.png": 47111,
	"./blog/posts/10-examples-to-help-you-learn-jsonata/example-6.1.png": 13738,
	"./blog/posts/10-examples-to-help-you-learn-jsonata/example-6.2.png": 27925,
	"./blog/posts/10-examples-to-help-you-learn-jsonata/example-7.png": 7883,
	"./blog/posts/10-examples-to-help-you-learn-jsonata/example-8.png": 18788,
	"./blog/posts/10-examples-to-help-you-learn-jsonata/example-9.1.png": 70883,
	"./blog/posts/10-examples-to-help-you-learn-jsonata/example-9.2.png": 55783,
	"./blog/posts/10-examples-to-help-you-learn-jsonata/explorer.png": 81711,
	"./blog/posts/announcing-notecard-firmware-531/banner.png": 47542,
	"./blog/posts/backup-power-with-scoop/banner.png": 62773,
	"./blog/posts/backup-power-with-scoop/scoop-back-v1-2x-size.png": 57873,
	"./blog/posts/backup-power-with-scoop/scoop-back-v1.png": 44151,
	"./blog/posts/backup-power-with-scoop/scoop-front-v1-2x-size.png": 93952,
	"./blog/posts/backup-power-with-scoop/scoop-front-v1.png": 79844,
	"./blog/posts/behind-the-amplifier-ben-lim/banner.jpg": 56193,
	"./blog/posts/behind-the-amplifier-ben-lim/chicago-cta-pcb.jpg": 82246,
	"./blog/posts/behind-the-amplifier-ben-lim/simple-wireless.jpg": 52975,
	"./blog/posts/behind-the-amplifier-dishant/banner.jpg": 31279,
	"./blog/posts/behind-the-amplifier-dishant/dishant-event.jpg": 18379,
	"./blog/posts/behind-the-amplifier-dishant/dishant-inventory.png": 42923,
	"./blog/posts/behind-the-amplifier-dishant/dishant-worksafe.png": 4424,
	"./blog/posts/behind-the-amplifier-justin-lutz/banner.jpg": 33570,
	"./blog/posts/behind-the-amplifier-justin-lutz/water-quality.webp": 63088,
	"./blog/posts/behind-the-amplifier-naveen-kumar/banner.jpg": 88376,
	"./blog/posts/behind-the-amplifier-naveen-kumar/fall-detection.jpg": 33773,
	"./blog/posts/behind-the-amplifier-naveen-kumar/faucet-alert.jpg": 37319,
	"./blog/posts/behind-the-amplifier-naveen-kumar/naveen-awards.png": 93804,
	"./blog/posts/behind-the-amplifier-pradeep/banner.png": 82849,
	"./blog/posts/behind-the-amplifier-pradeep/electromaker.png": 26290,
	"./blog/posts/behind-the-amplifier-pradeep/hydro.png": 52921,
	"./blog/posts/behind-the-amplifier-pradeep/quality.png": 44730,
	"./blog/posts/behind-the-amplifier-pradeep/thewild.png": 36436,
	"./blog/posts/behind-the-amplifier-prasannaa-kumar/award.jpg": 6549,
	"./blog/posts/behind-the-amplifier-prasannaa-kumar/banner.jpg": 87276,
	"./blog/posts/behind-the-amplifier-prasannaa-kumar/indoor-risk.png": 87223,
	"./blog/posts/behind-the-amplifier-prasannaa-kumar/solar-radio.jpg": 42431,
	"./blog/posts/blues-at-fab23-bhutan/1st.png": 11606,
	"./blog/posts/blues-at-fab23-bhutan/2nd.png": 17688,
	"./blog/posts/blues-at-fab23-bhutan/3rd.png": 31154,
	"./blog/posts/blues-at-fab23-bhutan/4th.png": 34800,
	"./blog/posts/blues-at-fab23-bhutan/5th.png": 50116,
	"./blog/posts/blues-at-fab23-bhutan/6th.png": 73314,
	"./blog/posts/blues-at-fab23-bhutan/7th.png": 81434,
	"./blog/posts/blues-at-fab23-bhutan/banner.png": 47042,
	"./blog/posts/blues-edge-impulse-accuracy-ml/banner.jpg": 68562,
	"./blog/posts/blues-edge-impulse-accuracy-ml/edge-impulse-screenshot.png": 34893,
	"./blog/posts/blues-edge-impulse-accuracy-ml/industrial-pumps.jpg": 75365,
	"./blog/posts/blues-hackster-build2gether-challenge/banner.webp": 92954,
	"./blog/posts/blues-hackster-build2gether-challenge/build2gether.png": 82562,
	"./blog/posts/blues-hackster-build2gether-challenge/kickboard.webp": 10542,
	"./blog/posts/blues-hackster-build2gether-challenge/smart-assistant.webp": 84082,
	"./blog/posts/blues-hackster-build2gether-challenge/space-invaders.webp": 12602,
	"./blog/posts/blues-hackster-build2gether-challenge/toilet-lora.webp": 2731,
	"./blog/posts/blues-iot-survey-2023-results/banner.jpg": 79126,
	"./blog/posts/blues-iot-survey-2023-results/survey-1.png": 16886,
	"./blog/posts/blues-iot-survey-2023-results/survey-10.png": 30781,
	"./blog/posts/blues-iot-survey-2023-results/survey-2.png": 63682,
	"./blog/posts/blues-iot-survey-2023-results/survey-3.png": 47486,
	"./blog/posts/blues-iot-survey-2023-results/survey-4.png": 66493,
	"./blog/posts/blues-iot-survey-2023-results/survey-5.png": 49785,
	"./blog/posts/blues-iot-survey-2023-results/survey-6.png": 4073,
	"./blog/posts/blues-iot-survey-2023-results/survey-7.png": 71420,
	"./blog/posts/blues-iot-survey-2023-results/survey-8.png": 94768,
	"./blog/posts/blues-iot-survey-2023-results/survey-9.png": 90294,
	"./blog/posts/blues-lora-things-conference/banner.jpg": 82649,
	"./blog/posts/blues-lora-things-conference/blues-booth-conversation.jpg": 69292,
	"./blog/posts/blues-lora-things-conference/blues-booth.jpg": 28663,
	"./blog/posts/blues-lora-things-conference/brandon-panel.jpg": 9760,
	"./blog/posts/blues-lora-things-conference/brandon-workshop.jpg": 81837,
	"./blog/posts/blues-lora-things-conference/jim-hassman.jpg": 2637,
	"./blog/posts/blues-lora-things-conference/new-notecards.png": 17846,
	"./blog/posts/blues-lora-things-conference/notecard-current-ranger.jpg": 45014,
	"./blog/posts/blues-lora-things-conference/ray-ozzie.jpg": 27308,
	"./blog/posts/blues-lora-things-conference/swing.jpg": 44558,
	"./blog/posts/blues-lora-things-conference/ttc.jpg": 47070,
	"./blog/posts/build-power-efficient-iot-with-notecard/all-notecards.png": 75640,
	"./blog/posts/build-power-efficient-iot-with-notecard/banner.jpg": 69210,
	"./blog/posts/build-power-efficient-iot-with-notecard/ota-dfu.png": 21322,
	"./blog/posts/building-a-connected-clock-with-blues-part-1/final-clock.jpg": 84990,
	"./blog/posts/building-a-connected-clock-with-blues-part-1/notehub-proxy-route.png": 84916,
	"./blog/posts/building-a-connected-clock-with-blues-part-1/simple-clock.jpg": 27011,
	"./blog/posts/building-a-connected-clock-with-blues-part-1/stopped-clock-noloop.gif": 35791,
	"./blog/posts/building-notecard/AOI-post-reflow.jpg": 81787,
	"./blog/posts/building-notecard/OI-paste.jpg": 72878,
	"./blog/posts/building-notecard/banner.jpg": 71243,
	"./blog/posts/building-notecard/depanel-1.jpg": 52744,
	"./blog/posts/building-notecard/depanel-fixture-1.jpg": 78148,
	"./blog/posts/building-notecard/depanel-fixture-2.jpg": 68877,
	"./blog/posts/building-notecard/ic-cart.jpg": 89591,
	"./blog/posts/building-notecard/inside-pnp-machine.jpg": 86051,
	"./blog/posts/building-notecard/inside-reflow-oven.jpg": 59876,
	"./blog/posts/building-notecard/inspection-pass.jpg": 68655,
	"./blog/posts/building-notecard/into-reflow-oven.jpg": 43307,
	"./blog/posts/building-notecard/notecard-front-2x.png": 77016,
	"./blog/posts/building-notecard/notecard-panel-2.jpg": 34389,
	"./blog/posts/building-notecard/notecard-panel.jpg": 52426,
	"./blog/posts/building-notecard/notecard-paste.jpg": 17662,
	"./blog/posts/building-notecard/packing.jpg": 67392,
	"./blog/posts/building-notecard/paste-app-machine.jpg": 44074,
	"./blog/posts/building-notecard/paste-application.jpg": 40970,
	"./blog/posts/building-notecard/pnp-cart-load.jpg": 33484,
	"./blog/posts/building-notecard/pnp-header.jpg": 25194,
	"./blog/posts/building-notecard/pnp-ic.jpg": 90204,
	"./blog/posts/building-notecard/routing-fixture.jpg": 25218,
	"./blog/posts/building-notecard/software-testing.jpg": 54066,
	"./blog/posts/building-notecard/two-pnp-machines.jpg": 58665,
	"./blog/posts/building-notecard/visual-inspection.jpg": 26235,
	"./blog/posts/cell-tower-wifi-triangulation-without-gps/card.triangulate.png": 91723,
	"./blog/posts/cell-tower-wifi-triangulation-without-gps/cell-triangulation.png": 39222,
	"./blog/posts/cell-tower-wifi-triangulation-without-gps/triangulation-cell-towers.png": 74056,
	"./blog/posts/cell-tower-wifi-triangulation-without-gps/triangulation-cell-wifi.png": 65037,
	"./blog/posts/cell-tower-wifi-triangulation-without-gps/triangulation-single-cell-tower.png": 909,
	"./blog/posts/cell-tower-wifi-triangulation-without-gps/triangulation-wifi-notecard.png": 52358,
	"./blog/posts/cell-tower-wifi-triangulation-without-gps/where-am-i.gif": 66121,
	"./blog/posts/cell-tower-wifi-triangulation-without-gps/wifi-cell-blog.png": 85899,
	"./blog/posts/debugging-stm32-esp32/add-breakpoint.png": 83565,
	"./blog/posts/debugging-stm32-esp32/banner.jpg": 79509,
	"./blog/posts/debugging-stm32-esp32/esp-prog-pinout.png": 31430,
	"./blog/posts/debugging-stm32-esp32/esp-prog.png": 43827,
	"./blog/posts/debugging-stm32-esp32/esp32-watch-variable.png": 31795,
	"./blog/posts/debugging-stm32-esp32/huzzah-wiring.jpg": 83855,
	"./blog/posts/debugging-stm32-esp32/start-debugging.png": 85335,
	"./blog/posts/debugging-stm32-esp32/step-over.png": 27701,
	"./blog/posts/debugging-stm32-esp32/swan-stlink-full.jpg": 91576,
	"./blog/posts/debugging-stm32-esp32/swan-stlink.jpg": 54060,
	"./blog/posts/debugging-stm32-esp32/watch-variables.png": 92044,
	"./blog/posts/differences-ltem-nbiot-cat1-cellular-iot/banner.jpg": 52686,
	"./blog/posts/differences-ltem-nbiot-cat1-cellular-iot/lte-m-coverage.png": 18218,
	"./blog/posts/differences-ltem-nbiot-cat1-cellular-iot/nbiot-coverage.png": 66704,
	"./blog/posts/digitalizing-the-wild-with-blues/banner.jpg": 15582,
	"./blog/posts/digitalizing-the-wild-with-blues/elephant.png": 76261,
	"./blog/posts/digitalizing-the-wild-with-blues/image1.png": 8885,
	"./blog/posts/digitalizing-the-wild-with-blues/image11.png": 24388,
	"./blog/posts/digitalizing-the-wild-with-blues/image12.png": 55734,
	"./blog/posts/digitalizing-the-wild-with-blues/image13.png": 2804,
	"./blog/posts/digitalizing-the-wild-with-blues/image14.png": 21114,
	"./blog/posts/digitalizing-the-wild-with-blues/image15.png": 28431,
	"./blog/posts/digitalizing-the-wild-with-blues/image16.png": 11875,
	"./blog/posts/digitalizing-the-wild-with-blues/image17.png": 83382,
	"./blog/posts/digitalizing-the-wild-with-blues/image18.png": 49769,
	"./blog/posts/digitalizing-the-wild-with-blues/image19.png": 58733,
	"./blog/posts/digitalizing-the-wild-with-blues/image2.png": 85991,
	"./blog/posts/digitalizing-the-wild-with-blues/image20.png": 34594,
	"./blog/posts/digitalizing-the-wild-with-blues/image21.png": 29979,
	"./blog/posts/digitalizing-the-wild-with-blues/image22.png": 16503,
	"./blog/posts/digitalizing-the-wild-with-blues/image23.png": 57260,
	"./blog/posts/digitalizing-the-wild-with-blues/image24.png": 10849,
	"./blog/posts/digitalizing-the-wild-with-blues/image25.png": 83108,
	"./blog/posts/digitalizing-the-wild-with-blues/image26.png": 66216,
	"./blog/posts/digitalizing-the-wild-with-blues/image27.png": 79006,
	"./blog/posts/digitalizing-the-wild-with-blues/image28.png": 60737,
	"./blog/posts/digitalizing-the-wild-with-blues/image29.png": 92313,
	"./blog/posts/digitalizing-the-wild-with-blues/image3.png": 18559,
	"./blog/posts/digitalizing-the-wild-with-blues/image30.png": 47012,
	"./blog/posts/digitalizing-the-wild-with-blues/image31.png": 1008,
	"./blog/posts/digitalizing-the-wild-with-blues/image32.png": 52308,
	"./blog/posts/digitalizing-the-wild-with-blues/image33.png": 34433,
	"./blog/posts/digitalizing-the-wild-with-blues/image34.png": 53042,
	"./blog/posts/digitalizing-the-wild-with-blues/image35.png": 2727,
	"./blog/posts/digitalizing-the-wild-with-blues/image36.png": 41733,
	"./blog/posts/digitalizing-the-wild-with-blues/image37.png": 19431,
	"./blog/posts/digitalizing-the-wild-with-blues/image4.png": 96115,
	"./blog/posts/digitalizing-the-wild-with-blues/image5.png": 71912,
	"./blog/posts/digitalizing-the-wild-with-blues/image6.png": 1710,
	"./blog/posts/digitalizing-the-wild-with-blues/image7.png": 20725,
	"./blog/posts/digitalizing-the-wild-with-blues/image8.png": 14231,
	"./blog/posts/digitalizing-the-wild-with-blues/image9.png": 52578,
	"./blog/posts/do-not-at-me/Notecard-crop.png": 89348,
	"./blog/posts/do-not-at-me/banner.jpg": 9748,
	"./blog/posts/do-not-at-me/secure-crop.png": 13484,
	"./blog/posts/dynamically-switching-wifi-networks/banner.png": 99044,
	"./blog/posts/dynamically-switching-wifi-networks/flow.png": 21646,
	"./blog/posts/dynamically-switching-wifi-networks/notehub-env-var-2.png": 99476,
	"./blog/posts/dynamically-switching-wifi-networks/notehub-env-var.png": 22565,
	"./blog/posts/dynamically-switching-wifi-networks/terminal.png": 15870,
	"./blog/posts/easiest-cellular-raspberry-pi-zero/banner.jpg": 73535,
	"./blog/posts/easiest-cellular-raspberry-pi-zero/blues-flow.jpg": 9541,
	"./blog/posts/easiest-cellular-raspberry-pi-zero/molex-antenna-pi.jpg": 78096,
	"./blog/posts/easiest-cellular-raspberry-pi-zero/notecard-slot.gif": 60826,
	"./blog/posts/easiest-cellular-raspberry-pi-zero/notecard.png": 84237,
	"./blog/posts/easiest-cellular-raspberry-pi-zero/notecarrier-pi-on-zero.jpg": 24719,
	"./blog/posts/easiest-cellular-raspberry-pi-zero/notecarrier-pi.png": 18333,
	"./blog/posts/easiest-cellular-raspberry-pi-zero/notehub-pi-zero.png": 98490,
	"./blog/posts/easiest-cellular-raspberry-pi-zero/pi-zero-2.jpg": 25058,
	"./blog/posts/easiest-cellular-raspberry-pi-zero/pizero.jpg": 61527,
	"./blog/posts/easiest-way-to-add-cellular-to-an-esp32-iot-project/adafruit-huzzah32.jpg": 91321,
	"./blog/posts/easiest-way-to-add-cellular-to-an-esp32-iot-project/banner.jpg": 47530,
	"./blog/posts/easiest-way-to-add-cellular-to-an-esp32-iot-project/blues-flow.jpg": 23067,
	"./blog/posts/easiest-way-to-add-cellular-to-an-esp32-iot-project/index-hdr-easiest-esp32.jpg": 20280,
	"./blog/posts/easiest-way-to-add-cellular-to-an-esp32-iot-project/notecard-esp32-joke.jpg": 28454,
	"./blog/posts/easiest-way-to-add-cellular-to-an-esp32-iot-project/notecard-notecarrier-a.jpg": 31461,
	"./blog/posts/easiest-way-to-add-cellular-to-an-esp32-iot-project/notecard.png": 20246,
	"./blog/posts/easiest-way-to-add-cellular-to-an-esp32-iot-project/notecarrier-af.png": 34557,
	"./blog/posts/easiest-way-to-add-cellular-to-an-esp32-iot-project/notecarrier-f-front.png": 59956,
	"./blog/posts/easiest-way-to-add-cellular-to-an-esp32-iot-project/notehub-events.png": 76489,
	"./blog/posts/easiest-way-to-add-cellular-to-an-esp32-iot-project/notehub-productuid.png": 71995,
	"./blog/posts/easiest-way-to-add-cellular-to-an-esp32-iot-project/ubidots.gif": 51829,
	"./blog/posts/embedded-c-unit-testing/banner.png": 79282,
	"./blog/posts/embedded-c-unit-testing/lcov_index_page.png": 64510,
	"./blog/posts/embedded-c-unit-testing/notenewrequest_coverage.png": 87131,
	"./blog/posts/encrypt-secure-cellular-data/banner.jpg": 82510,
	"./blog/posts/encrypt-secure-cellular-data/blues-flow.jpg": 10214,
	"./blog/posts/encrypt-secure-cellular-data/notehub-security.png": 91289,
	"./blog/posts/firmware-cellular-wifi-lora/banner.jpg": 4496,
	"./blog/posts/firmware-cellular-wifi-lora/notehub-events.png": 15606,
	"./blog/posts/firmware-cellular-wifi-lora/serial-log.png": 41413,
	"./blog/posts/firmware-tips-and-tricks/ai-results-2.png": 53221,
	"./blog/posts/firmware-tips-and-tricks/ai-results.png": 52368,
	"./blog/posts/firmware-tips-and-tricks/airnote-data.png": 84587,
	"./blog/posts/firmware-tips-and-tricks/banner.png": 6195,
	"./blog/posts/firmware-tips-and-tricks/copilot-editor.png": 18674,
	"./blog/posts/firmware-tips-and-tricks/data.png": 84569,
	"./blog/posts/firmware-tips-and-tricks/git-status.png": 68285,
	"./blog/posts/firmware-tips-and-tricks/google-results.png": 78278,
	"./blog/posts/firmware-tips-and-tricks/kid-tracker.png": 78817,
	"./blog/posts/firmware-tips-and-tricks/pest-detector-hardware.png": 48575,
	"./blog/posts/firmware-tips-and-tricks/pest-detector.png": 74485,
	"./blog/posts/firmware-tips-and-tricks/platformio-config.png": 78522,
	"./blog/posts/firmware-tips-and-tricks/platformio-keyboard.png": 56379,
	"./blog/posts/get-ready-for-starnote/banner.png": 21084,
	"./blog/posts/get-ready-for-starnote/notehub-event.png": 36405,
	"./blog/posts/getting-started-with-raspberry-pi-pico-and-blues-notecard/banner.jpg": 67456,
	"./blog/posts/getting-started-with-raspberry-pi-pico-and-blues-notecard/copying-library-with-thonny.gif": 8547,
	"./blog/posts/getting-started-with-raspberry-pi-pico-and-blues-notecard/notecard-setup.jpg": 32153,
	"./blog/posts/guide-upgrade-raspberry-pi-buster-bullseye/banner.jpg": 71545,
	"./blog/posts/hands-on-cellular-pi5/banner.jpg": 81863,
	"./blog/posts/hands-on-cellular-pi5/pi-5.png": 71205,
	"./blog/posts/hands-on-cellular-pi5/pi5-notecarrier.jpg": 48895,
	"./blog/posts/how-to-build-an-asset-tracker-with-geofence-alerts/banner.png": 74733,
	"./blog/posts/how-to-build-an-asset-tracker-with-geofence-alerts/full-url-testing.png": 97743,
	"./blog/posts/how-to-build-an-asset-tracker-with-geofence-alerts/function-in-postman.png": 58617,
	"./blog/posts/how-to-build-an-asset-tracker-with-geofence-alerts/geofence-testing-2.png": 91096,
	"./blog/posts/how-to-build-an-asset-tracker-with-geofence-alerts/geofence-testing.png": 907,
	"./blog/posts/how-to-build-an-asset-tracker-with-geofence-alerts/geofence.png": 59417,
	"./blog/posts/how-to-build-an-asset-tracker-with-geofence-alerts/michigan.png": 81501,
	"./blog/posts/how-to-build-an-asset-tracker-with-geofence-alerts/netlify-url.png": 62408,
	"./blog/posts/how-to-build-an-asset-tracker-with-geofence-alerts/notecard-and-notecarrier-a.jpg": 72530,
	"./blog/posts/how-to-build-an-asset-tracker-with-geofence-alerts/notecard.png": 66609,
	"./blog/posts/how-to-build-an-asset-tracker-with-geofence-alerts/notehub-routing.png": 45763,
	"./blog/posts/how-to-build-an-asset-tracker-with-geofence-alerts/route-1.png": 9777,
	"./blog/posts/how-to-build-an-asset-tracker-with-geofence-alerts/route-2.png": 80255,
	"./blog/posts/how-to-build-an-asset-tracker-with-geofence-alerts/route-log.png": 4439,
	"./blog/posts/how-to-build-an-asset-tracker-with-geofence-alerts/sms.jpg": 20666,
	"./blog/posts/how-to-build-an-asset-tracker-with-geofence-alerts/track-qo-events.png": 41690,
	"./blog/posts/m5stack-uiflow-integration-with-blues/access-point-block.png": 57252,
	"./blog/posts/m5stack-uiflow-integration-with-blues/api-key.png": 17770,
	"./blog/posts/m5stack-uiflow-integration-with-blues/background-on-hardware.png": 85679,
	"./blog/posts/m5stack-uiflow-integration-with-blues/banner.png": 38363,
	"./blog/posts/m5stack-uiflow-integration-with-blues/device-connection.png": 84074,
	"./blog/posts/m5stack-uiflow-integration-with-blues/dummy-sensor-values.png": 24735,
	"./blog/posts/m5stack-uiflow-integration-with-blues/expected-response.png": 3007,
	"./blog/posts/m5stack-uiflow-integration-with-blues/final-block.png": 32675,
	"./blog/posts/m5stack-uiflow-integration-with-blues/final-notehub-response.png": 48015,
	"./blog/posts/m5stack-uiflow-integration-with-blues/final-project.gif": 48953,
	"./blog/posts/m5stack-uiflow-integration-with-blues/firmware-burner.png": 46398,
	"./blog/posts/m5stack-uiflow-integration-with-blues/firmware-installation.png": 11888,
	"./blog/posts/m5stack-uiflow-integration-with-blues/hardware-setup.png": 60566,
	"./blog/posts/m5stack-uiflow-integration-with-blues/notehub-connection.png": 22426,
	"./blog/posts/m5stack-uiflow-integration-with-blues/productuid.png": 28951,
	"./blog/posts/m5stack-uiflow-integration-with-blues/screen-background.png": 64623,
	"./blog/posts/m5stack-uiflow-integration-with-blues/serial-terminal-response.png": 44931,
	"./blog/posts/m5stack-uiflow-integration-with-blues/simple-block.png": 98212,
	"./blog/posts/m5stack-uiflow-integration-with-blues/simple-program.png": 84866,
	"./blog/posts/m5stack-uiflow-integration-with-blues/status-bar.png": 48860,
	"./blog/posts/m5stack-uiflow-integration-with-blues/uart-config.png": 28988,
	"./blog/posts/m5stack-uiflow-integration-with-blues/uart-menu.png": 33679,
	"./blog/posts/m5stack-uiflow-integration-with-blues/uiflow-settings.png": 52071,
	"./blog/posts/m5stack-uiflow-integration-with-blues/uiflow-setup.png": 85270,
	"./blog/posts/m5stack-uiflow-integration-with-blues/wifi-details.png": 57398,
	"./blog/posts/maker-faire-hyderabad-recap/banner.png": 26183,
	"./blog/posts/maker-faire-hyderabad-recap/booth1.png": 36261,
	"./blog/posts/maker-faire-hyderabad-recap/booth2.png": 27082,
	"./blog/posts/maker-faire-hyderabad-recap/booth3.png": 14235,
	"./blog/posts/maker-faire-hyderabad-recap/project1.png": 71178,
	"./blog/posts/maker-faire-hyderabad-recap/project2.png": 44229,
	"./blog/posts/micro-sd-card-arduino/banner.jpg": 24218,
	"./blog/posts/micro-sd-card-arduino/bmp-png-jpg-comparison.png": 99662,
	"./blog/posts/micro-sd-card-arduino/bob-ross.gif": 61877,
	"./blog/posts/micro-sd-card-arduino/swan-sd.jpg": 96323,
	"./blog/posts/micro-sd-card-arduino/testimg.png": 62348,
	"./blog/posts/most-valuable-hackster/2nd.png": 31228,
	"./blog/posts/most-valuable-hackster/banner.png": 60601,
	"./blog/posts/next-generation-of-notecards/CARR-F.png": 31420,
	"./blog/posts/next-generation-of-notecards/NBGLW.jpg": 31190,
	"./blog/posts/next-generation-of-notecards/NBNAW.jpg": 95630,
	"./blog/posts/next-generation-of-notecards/NOTE-ESP.jpg": 33189,
	"./blog/posts/next-generation-of-notecards/WBEXW.jpg": 42717,
	"./blog/posts/next-generation-of-notecards/WBGLW.jpg": 85272,
	"./blog/posts/next-generation-of-notecards/WBNAW.jpg": 11735,
	"./blog/posts/next-generation-of-notecards/banner.jpg": 99062,
	"./blog/posts/notecard-lora-release/banner.jpg": 24498,
	"./blog/posts/notecard-lora-release/lorawan-starter-kit.jpg": 84407,
	"./blog/posts/notecard-lora-release/notecard-lora.jpg": 78203,
	"./blog/posts/notehub-features-aug-2023/banner.png": 58449,
	"./blog/posts/notehub-features-aug-2023/datacake-route.png": 59816,
	"./blog/posts/notehub-features-aug-2023/env-var-inheritance.png": 41903,
	"./blog/posts/notehub-features-aug-2023/global-transform.png": 61072,
	"./blog/posts/raspberry-pi-pico-pio/banner.jpg": 1442,
	"./blog/posts/raspberry-pi-pico-pio/nintendo-rob.png": 16182,
	"./blog/posts/raspberry-pi-pico-pio/pico-pio.gif": 84078,
	"./blog/posts/raspberry-pi-pico-pio/pico.jpg": 96299,
	"./blog/posts/raspberry-pi-pico-pio/pio-block.png": 84210,
	"./blog/posts/raspberry-pi-pico-pio/raspberry-pi-pico.png": 27215,
	"./blog/posts/revolutionize-automation-game/banner.jpg": 77346,
	"./blog/posts/revolutionize-automation-game/cloud-workflow.png": 45083,
	"./blog/posts/revolutionize-automation-game/completed-project.png": 59,
	"./blog/posts/revolutionize-automation-game/lattepanda-arduino.png": 58966,
	"./blog/posts/revolutionize-automation-game/node-red-dashboard.png": 4264,
	"./blog/posts/revolutionize-automation-game/node-red-install.png": 25810,
	"./blog/posts/revolutionize-automation-game/node-red-workflow.png": 51708,
	"./blog/posts/revolutionize-automation-game/notehub-events.png": 16306,
	"./blog/posts/revolutionize-automation-game/notehub-new-project.png": 69287,
	"./blog/posts/revolutionize-automation-game/project-hardware.png": 34655,
	"./blog/posts/revolutionize-automation-game/qubitro.png": 31189,
	"./blog/posts/revolutionize-automation-game/serial-monitor.png": 14204,
	"./blog/posts/revolutionize-automation-game/voice-commands.png": 86422,
	"./blog/posts/revolutionize-automation-game/voice-sensor.png": 71053,
	"./blog/posts/revolutionize-automation-game/wiring.png": 25790,
	"./blog/posts/robust-ml-ops-workflow/accelerometer-readings.gif": 33349,
	"./blog/posts/robust-ml-ops-workflow/apply-host-firmware.png": 45463,
	"./blog/posts/robust-ml-ops-workflow/banner.png": 19379,
	"./blog/posts/robust-ml-ops-workflow/hardware.jpg": 13670,
	"./blog/posts/robust-ml-ops-workflow/log-version-2.png": 38602,
	"./blog/posts/robust-ml-ops-workflow/mlops.png": 17655,
	"./blog/posts/robust-ml-ops-workflow/ngrok.png": 1815,
	"./blog/posts/robust-ml-ops-workflow/notehub-firmware.png": 64584,
	"./blog/posts/robust-ml-ops-workflow/proxy-route.png": 78024,
	"./blog/posts/robust-ml-ops-workflow/starterkit.jpg": 37619,
	"./blog/posts/robust-ml-ops-workflow/workflow.gif": 84177,
	"./blog/posts/send-receive-binary-files/banner.jpg": 3818,
	"./blog/posts/send-receive-binary-files/create-https-route.png": 91941,
	"./blog/posts/send-receive-binary-files/create-web-route.png": 79595,
	"./blog/posts/send-receive-binary-files/hardware.jpg": 47825,
	"./blog/posts/send-receive-binary-files/logo.jpg": 13622,
	"./blog/posts/send-receive-binary-files/route-get-image.png": 79899,
	"./blog/posts/send-receive-binary-files/route-post-binary.png": 81245,
	"./blog/posts/send-receive-binary-files/route-post-image.png": 96642,
	"./blog/posts/send-receive-binary-files/webhook.png": 50425,
	"./blog/posts/start-rapid-prototyping/banner.jpg": 43870,
	"./blog/posts/start-rapid-prototyping/seed-grove-haptic.jpeg": 34989,
	"./blog/posts/start-rapid-prototyping/sparkfun-micromod-blues.jpeg": 45086,
	"./blog/posts/start-rapid-prototyping/sparkfun-pressure-sensor-qwiic.jpeg": 66185,
	"./blog/posts/start-rapid-prototyping/stemma-moisture-sensor.png": 68496,
	"./blog/posts/tadiran-lipo/banner.jpg": 15677,
	"./blog/posts/tadiran-lipo/duracell-aa.png": 56278,
	"./blog/posts/tadiran-lipo/lipo-battery-shape.jpg": 96399,
	"./blog/posts/tadiran-lipo/lipo-battery-structure.webp": 20897,
	"./blog/posts/tadiran-lipo/lipo-example.png": 86611,
	"./blog/posts/tadiran-lipo/lisocl2-battery-structure.jpg": 47342,
	"./blog/posts/tadiran-lipo/tadiran-blues.webp": 55655,
	"./blog/posts/tadiran-lipo/tadiran-extreme.png": 93971,
	"./blog/posts/tadiran-lipo/tadiran-pulseplus.jpg": 37506,
	"./blog/posts/tips-tricks-optimizing-raspberry-pi-power/banner.jpg": 9720,
	"./blog/posts/tips-tricks-optimizing-raspberry-pi-power/blog-back-to-the-future.gif": 11438,
	"./blog/posts/tips-tricks-optimizing-raspberry-pi-power/notecard.png": 9320,
	"./blog/posts/tips-tricks-optimizing-raspberry-pi-power/notecarrier-pi.jpg": 74448,
	"./blog/posts/tips-tricks-optimizing-raspberry-pi-power/pijuice-solar.jpg": 49047,
	"./blog/posts/tips-tricks-optimizing-raspberry-pi-power/rpi-power.png": 15951,
	"./blog/posts/tips-tricks-optimizing-raspberry-pi-power/rpi.jpg": 87327,
	"./blog/posts/upgrade-bullseye-bookworm/banner.png": 48460,
	"./blog/posts/upgrade-bullseye-bookworm/bookworm-desktop.png": 84603,
	"./blog/posts/upgrade-bullseye-bookworm/lazy.gif": 25855,
	"./blog/posts/upgrade-bullseye-bookworm/live-dangerously.gif": 96052,
	"./blog/posts/upgrade-bullseye-bookworm/rpi-and-notecarrier.webp": 17025,
	"./blog/posts/upgrade-bullseye-bookworm/update-wait.png": 26754,
	"./blog/posts/using-an-external-gps-with-the-notecard/adafruit-gps.png": 11529,
	"./blog/posts/using-an-external-gps-with-the-notecard/banner.jpg": 61810,
	"./blog/posts/using-an-external-gps-with-the-notecard/individual-track-event.png": 51571,
	"./blog/posts/using-an-external-gps-with-the-notecard/map.jpg": 67904,
	"./blog/posts/using-an-external-gps-with-the-notecard/notecard-diagram.png": 49735,
	"./blog/posts/using-an-external-gps-with-the-notecard/notehub-event.png": 25092,
	"./blog/posts/using-an-external-gps-with-the-notecard/terminal-usage.png": 42000,
	"./blog/posts/using-an-external-gps-with-the-notecard/track-qo-events.png": 36675,
	"./blog/posts/using-an-external-gps-with-the-notecard/wiring.jpg": 77444,
	"./blog/posts/using-gps-wifi-tri-together/banner.png": 10882,
	"./blog/posts/using-gps-wifi-tri-together/best-fields.png": 45089,
	"./blog/posts/using-gps-wifi-tri-together/track-qo-event-details.png": 37178,
	"./blog/posts/using-gps-wifi-tri-together/track-qo-events.png": 82468,
	"./blog/posts/using-gps-wifi-tri-together/tri-frequency.webp": 20383,
	"./blog/posts/using-gps-wifi-tri-together/triangulated-location.png": 37139,
	"./blog/posts/using-gps-wifi-tri-together/triangulation-points.png": 41993,
	"./blog/posts/waylay-integration/banner.png": 27249,
	"./blog/posts/waylay-integration/notecard-simulator.png": 49225,
	"./blog/posts/waylay-integration/notehub-route-https.png": 72498,
	"./blog/posts/waylay-integration/routing.png": 53093,
	"./blog/posts/waylay-integration/waylay-account.png": 94789,
	"./blog/posts/waylay-integration/waylay-add-device.png": 26390,
	"./blog/posts/waylay-integration/waylay-alarm.png": 8537,
	"./blog/posts/waylay-integration/waylay-charts.png": 77494,
	"./blog/posts/waylay-integration/waylay-event.png": 19274,
	"./blog/posts/waylay-integration/waylay-features.png": 37210,
	"./blog/posts/waylay-integration/waylay-group.png": 17722,
	"./blog/posts/waylay-integration/waylay-integration.gif": 48180,
	"./blog/posts/waylay-integration/waylay-log.png": 94249,
	"./blog/posts/waylay-integration/waylay-org.png": 45159,
	"./blog/posts/waylay-integration/waylay-public-dashboard.png": 9769,
	"./blog/posts/waylay-integration/waylay-rules-engine.png": 94127,
	"./blog/posts/waylay-integration/waylay-task.png": 54930,
	"./blog/posts/waylay-integration/waylay-widget.png": 79735,
	"./blog/posts/waylay-integration/waylay.png": 80967,
	"./blog/posts/wifi-cellular-the-easy-way/banner.webp": 36011,
	"./blog/posts/wifi-cellular-the-easy-way/blues-flow.png": 14906,
	"./blog/posts/wifi-cellular-the-easy-way/events.png": 26205,
	"./blog/posts/wifi-cellular-the-easy-way/hardware-setup.png": 64382,
	"./blog/posts/wifi-cellular-the-easy-way/notecard-diagram.png": 20525,
	"./blog/posts/wifi-cellular-the-easy-way/notehub-project.png": 27052,
	"./blog/posts/zephyr-the-easy-way/accelerators.png": 56857,
	"./blog/posts/zephyr-the-easy-way/banner.png": 69772,
	"./blog/posts/zephyr-the-easy-way/complexity.png": 33603,
	"./blog/posts/zephyr-the-easy-way/dev-container.png": 71036,
	"./blog/posts/zephyr-the-easy-way/hardware.png": 17239,
	"./blog/posts/zephyr-the-easy-way/notecard.png": 94013,
	"./blog/posts/zephyr-the-easy-way/run-task.png": 53618,
	"./blog/posts/zephyr-the-easy-way/sensor-readings.png": 33994,
	"./blog/posts/zephyr-the-easy-way/terminal.png": 13244,
	"./community/amplifiers.svg": 69689,
	"./community/community-projects.svg": 81754,
	"./community/forum.svg": 84650,
	"./docs/notecard_playground.svg": 90165,
	"./docs/quickstart.svg": 45975,
	"./docs/tutorials.svg": 39956,
	"./firmware/stm32cube-erasing-lora.png": 27349,
	"./firmware/stm32cube-erasing.png": 73954,
	"./firmware/stm32cube-mac-security-allow.png": 74670,
	"./firmware/stm32cube-mac-security.png": 542,
	"./firmware/stm32cube-port.png": 63947,
	"./firmware/stm32cube-uart.png": 96176,
	"./firmware/stm32cube-usb.png": 69822,
	"./guides/cell-connectivity/antenna-main.jpg": 11599,
	"./guides/dfu-guide/arduino-binary.png": 42340,
	"./guides/dfu-guide/arduino-partition-menu.png": 83830,
	"./guides/dfu-guide/arduino-preferences-menu.png": 57900,
	"./guides/dfu-guide/dfu-complete.png": 32436,
	"./guides/dfu-guide/firmware-downloaded.png": 20715,
	"./guides/dfu-guide/firmware-screen-new.png": 5829,
	"./guides/dfu-guide/proceed.png": 62467,
	"./guides/dfu-guide/select-firmware.png": 8812,
	"./guides/dfu-guide/update-downloading.png": 53677,
	"./guides/dfu-guide/update-firmware.png": 78376,
	"./guides/dfu-guide/update-requested.png": 99094,
	"./guides/dfu-guide/upload-firmware.png": 89017,
	"./guides/dfu-guide/uploaded-firmware.png": 92236,
	"./guides/encryption-guide/events.png": 72547,
	"./guides/encryption-guide/notehub-nav.png": 81039,
	"./guides/encryption-guide/public-key-var.png": 75897,
	"./guides/first-sensor/arduino/arduino-serial-monitor.png": 84624,
	"./guides/first-sensor/arduino/arduino-tutorial-nano-33.jpg": 69071,
	"./guides/first-sensor/arduino/arduino-tutorial-serial-monitor.png": 40240,
	"./guides/first-sensor/arduino/boards-manager.png": 15964,
	"./guides/first-sensor/arduino/install-library.gif": 97443,
	"./guides/first-sensor/arduino/install-library.png": 2029,
	"./guides/first-sensor/arduino/nano-33-install.png": 59872,
	"./guides/first-sensor/arduino/pseudo-sensor-library.png": 99472,
	"./guides/first-sensor/arduino/select-nano.png": 608,
	"./guides/first-sensor/artemis/artemis-notecarrier.png": 24231,
	"./guides/first-sensor/artemis/artemis-qwiic.png": 40469,
	"./guides/first-sensor/artemis/bme-notecarrier.png": 1807,
	"./guides/first-sensor/artemis/bme-qwiic.png": 50868,
	"./guides/first-sensor/artemis/boards-mgr.png": 84160,
	"./guides/first-sensor/artemis/install-bme280.png": 8501,
	"./guides/first-sensor/artemis/install-board.png": 1343,
	"./guides/first-sensor/artemis/select-board.png": 21193,
	"./guides/first-sensor/circuitpython/cpy-libs.png": 11764,
	"./guides/first-sensor/circuitpython/esp32-cp-note-python.png": 88489,
	"./guides/first-sensor/circuitpython/esp32-cp-output.png": 25318,
	"./guides/first-sensor/circuitpython/install-bme.png": 80063,
	"./guides/first-sensor/circuitpython/install-note-python.png": 32242,
	"./guides/first-sensor/circuitpython/nc-configured-lib.png": 13203,
	"./guides/first-sensor/circuitpython/nc-configured.png": 89775,
	"./guides/first-sensor/circuitpython/note-python.png": 91170,
	"./guides/first-sensor/circuitpython/notes-lib.png": 86623,
	"./guides/first-sensor/circuitpython/notes-no-lib.png": 56887,
	"./guides/first-sensor/circuitpython/sensor-github-download.png": 28626,
	"./guides/first-sensor/circuitpython/sensor-library-move.png": 73235,
	"./guides/first-sensor/circuitpython/sensors-readings.png": 78061,
	"./guides/first-sensor/environment/device-screen.png": 14778,
	"./guides/first-sensor/environment/env-var-serial-log-circuitpython.png": 25997,
	"./guides/first-sensor/environment/env-var-serial-log.png": 83201,
	"./guides/first-sensor/environment/setting-a-variable.png": 78686,
	"./guides/first-sensor/esp32/connect-gnd.jpg": 20481,
	"./guides/first-sensor/esp32/connect-rx-tx.jpg": 74480,
	"./guides/first-sensor/esp32/connect-tx-rx.jpg": 60166,
	"./guides/first-sensor/esp32/connect-v.jpg": 50896,
	"./guides/first-sensor/feather/arduino-preferences.png": 6771,
	"./guides/first-sensor/feather/arduino-prefs-adafruit.png": 21533,
	"./guides/first-sensor/feather/arduino-tutorial-upload.png": 1656,
	"./guides/first-sensor/feather/boards-mgr-adafruit-samd.png": 64815,
	"./guides/first-sensor/feather/boards-mgr-arduino-samd.png": 59523,
	"./guides/first-sensor/feather/boards-mgr-menu.png": 65672,
	"./guides/first-sensor/feather/boards-mgr.png": 88373,
	"./guides/first-sensor/feather/boards-select-feather.png": 91629,
	"./guides/first-sensor/feather/connect-notecard-m4-express.jpg": 13706,
	"./guides/first-sensor/feather/connect-notecard-swan-i2c.jpg": 73376,
	"./guides/first-sensor/feather/connect-notecard-swan-serial.jpg": 40223,
	"./guides/first-sensor/feather/connect-notecard-swan.jpg": 81161,
	"./guides/first-sensor/feather/lib-dependencies.png": 77889,
	"./guides/first-sensor/feather/manage-libs.png": 25264,
	"./guides/first-sensor/feather/notes-lib.png": 64226,
	"./guides/first-sensor/feather/notes-mock-lib.png": 61119,
	"./guides/first-sensor/feather/notes-mock-no-lib.png": 77994,
	"./guides/first-sensor/feather/notes-no-lib.png": 29332,
	"./guides/first-sensor/feather/platform-io-add-to-project.png": 47714,
	"./guides/first-sensor/feather/platform-io-pseudo-library.png": 72422,
	"./guides/first-sensor/feather/platform-io-serial-monitor.png": 70821,
	"./guides/first-sensor/feather/platform-io-serial-output.png": 29423,
	"./guides/first-sensor/feather/platform-io-upload.png": 17691,
	"./guides/first-sensor/feather/prefs-menu.png": 4334,
	"./guides/first-sensor/feather/select-port.png": 84474,
	"./guides/first-sensor/feather/serial-configured.png": 87325,
	"./guides/first-sensor/feather/serial-readings.png": 68317,
	"./guides/first-sensor/feather/si-labs-driver.png": 99877,
	"./guides/first-sensor/notecarrier-af/AF-esp32.png": 47257,
	"./guides/first-sensor/notecarrier-af/AF-m4-cpy-bme680.png": 51359,
	"./guides/first-sensor/notecarrier-af/AF-m4.png": 16508,
	"./guides/first-sensor/notecarrier-af/AF-solo.png": 19992,
	"./guides/first-sensor/notecarrier-af/AF-stm32-bme680.png": 16882,
	"./guides/first-sensor/notecarrier-af/AF-stm32.png": 52942,
	"./guides/first-sensor/notecarrier-af/AF-swan.jpg": 12121,
	"./guides/first-sensor/notecarrier-f/carr-f-esp32.jpg": 7414,
	"./guides/first-sensor/notecarrier-f/carr-f-m4.jpg": 66166,
	"./guides/first-sensor/notecarrier-f/carr-f-swan.jpg": 44993,
	"./guides/first-sensor/rpi/arm-i2c.png": 93464,
	"./guides/first-sensor/rpi/finish.png": 39537,
	"./guides/first-sensor/rpi/grove-py-bme.png": 25511,
	"./guides/first-sensor/rpi/grove-py-install.png": 46704,
	"./guides/first-sensor/rpi/i2c-detect.png": 9912,
	"./guides/first-sensor/rpi/i2c-enabled.png": 52957,
	"./guides/first-sensor/rpi/interfacing-options.png": 36373,
	"./guides/first-sensor/rpi/login-serial.png": 66194,
	"./guides/first-sensor/rpi/note-python-github.png": 36319,
	"./guides/first-sensor/rpi/pi-i2c-detect.png": 84164,
	"./guides/first-sensor/rpi/py-sensors-capture.png": 27841,
	"./guides/first-sensor/rpi/select-i2c.png": 20740,
	"./guides/first-sensor/rpi/select-serial.png": 87393,
	"./guides/first-sensor/rpi/serial-confirm.png": 16544,
	"./guides/first-sensor/rpi/serial-hw-enabled.png": 52269,
	"./guides/first-sensor/sparkfun/boards-manager-url.png": 29192,
	"./guides/first-sensor/sparkfun/cellular-function-board.jpg": 2741,
	"./guides/first-sensor/sparkfun/sparkfun-board-install.png": 77564,
	"./guides/first-sensor/sparkfun/sparkfun-board-selection.png": 49979,
	"./guides/first-sensor/stm32/add-note-c.png": 71645,
	"./guides/first-sensor/stm32/arduino-preferences.png": 60856,
	"./guides/first-sensor/stm32/board-selector.png": 50304,
	"./guides/first-sensor/stm32/boards-mgr.png": 92753,
	"./guides/first-sensor/stm32/boards-select-adafruit-stm32.png": 98098,
	"./guides/first-sensor/stm32/boards-select-stm32.png": 25057,
	"./guides/first-sensor/stm32/boards-settings.png": 42912,
	"./guides/first-sensor/stm32/bosch-driver-copy.png": 90232,
	"./guides/first-sensor/stm32/bosch-driver-paths-symbols.png": 70209,
	"./guides/first-sensor/stm32/bosch-driver-source-location.png": 64011,
	"./guides/first-sensor/stm32/breakpoint.png": 65145,
	"./guides/first-sensor/stm32/command-shell-console.png": 75133,
	"./guides/first-sensor/stm32/config-discovery.png": 89649,
	"./guides/first-sensor/stm32/config-nucleo.png": 88352,
	"./guides/first-sensor/stm32/console-readings.png": 6483,
	"./guides/first-sensor/stm32/debug-console-connected.png": 1438,
	"./guides/first-sensor/stm32/debug-icon.png": 35925,
	"./guides/first-sensor/stm32/device-config.png": 74926,
	"./guides/first-sensor/stm32/discovery-bad-defaults.png": 36818,
	"./guides/first-sensor/stm32/discovery-bad-i2c4-default.png": 46010,
	"./guides/first-sensor/stm32/discovery-bad-usart2-default.png": 49365,
	"./guides/first-sensor/stm32/discovery-bme680-notecarrier-a.jpg": 48412,
	"./guides/first-sensor/stm32/discovery-bme680-notecarrier-aa.jpg": 38393,
	"./guides/first-sensor/stm32/discovery-bme680.jpg": 43644,
	"./guides/first-sensor/stm32/discovery-part-search.png": 79903,
	"./guides/first-sensor/stm32/discovery-pin-PA0-menu.png": 7360,
	"./guides/first-sensor/stm32/discovery-pin-PF13-menu.png": 19298,
	"./guides/first-sensor/stm32/enable-i2c.png": 46487,
	"./guides/first-sensor/stm32/generate-code.png": 79942,
	"./guides/first-sensor/stm32/i2c-config.png": 8498,
	"./guides/first-sensor/stm32/init-peripherals.png": 6919,
	"./guides/first-sensor/stm32/libncurses5-error.png": 15623,
	"./guides/first-sensor/stm32/new-serial-port-connection.png": 15824,
	"./guides/first-sensor/stm32/new-stm32-project.png": 11178,
	"./guides/first-sensor/stm32/note-c-copy.png": 27605,
	"./guides/first-sensor/stm32/nucleo-notecarrier-a.jpg": 75734,
	"./guides/first-sensor/stm32/nucleo-part-search.png": 76288,
	"./guides/first-sensor/stm32/pa10.png": 23753,
	"./guides/first-sensor/stm32/pa9.png": 27767,
	"./guides/first-sensor/stm32/paths-and-symbols.png": 85481,
	"./guides/first-sensor/stm32/pb6.png": 73293,
	"./guides/first-sensor/stm32/pb7.png": 58383,
	"./guides/first-sensor/stm32/project-name.png": 10947,
	"./guides/first-sensor/stm32/properties.png": 52382,
	"./guides/first-sensor/stm32/select-discovery.png": 21130,
	"./guides/first-sensor/stm32/select-nucleo.png": 8532,
	"./guides/first-sensor/stm32/select-remote-connection.png": 2954,
	"./guides/first-sensor/stm32/stmod-plus-connector-pinout.png": 21450,
	"./guides/first-sensor/stm32/uart-baud-nucleo.png": 95988,
	"./guides/first-sensor/stm32/uart-config.png": 60288,
	"./guides/first-sensor/stm32/uart-nvic-nucleo.png": 87180,
	"./guides/ftdi-guide/ftdi-cable.jpg": 31702,
	"./guides/ftdi-guide/ftdi-notecard-lipo-battery.jpg": 76483,
	"./guides/ftdi-guide/ftdi-notecarrier-connections.jpg": 96169,
	"./guides/ftdi-guide/ftdi-terminal-port.png": 7472,
	"./guides/ftdi-guide/ftdi-terminal-termination.png": 35242,
	"./guides/ftdi-guide/ftdi-terminal-trace.png": 55984,
	"./guides/gps-guide/device-location.png": 30580,
	"./guides/gps-guide/sensors-json.png": 72584,
	"./guides/gps-guide/tracker-json.png": 81127,
	"./guides/gps-guide/tracking-events.png": 47659,
	"./guides/gps-issues/antenna-gps.jpg": 91088,
	"./guides/gps-issues/keep-out-zones.jpg": 85225,
	"./guides/lora/app-all-devices.png": 50976,
	"./guides/lora/app-dash-copy.png": 86900,
	"./guides/lora/app-dash-edit.png": 32232,
	"./guides/lora/app-dash-gauge.png": 65806,
	"./guides/lora/app-dash-line.png": 54813,
	"./guides/lora/app-dash-value.png": 33960,
	"./guides/lora/app-dashboard.png": 80271,
	"./guides/lora/app-datacake-config.png": 82830,
	"./guides/lora/app-datacake-device.png": 1468,
	"./guides/lora/app-datacake-fields.png": 6426,
	"./guides/lora/app-datacake-route-config.png": 61078,
	"./guides/lora/app-datacake-routetype.png": 31812,
	"./guides/lora/app-device.png": 47597,
	"./guides/lora/app-deviceuid.png": 48762,
	"./guides/lora/app-jsonata-result.png": 21121,
	"./guides/lora/app-jsonata.result.png": 38912,
	"./guides/lora/app-lora-hardware-charging.jpg": 77131,
	"./guides/lora/app-lora-hardware-scoop.jpg": 87016,
	"./guides/lora/app-lora-hardware.jpg": 53116,
	"./guides/lora/app-notehub-events.png": 8450,
	"./guides/lora/app-route-notefiles.png": 63422,
	"./guides/lora/app-simple-dashboard.png": 40491,
	"./guides/lora/app-terminal.png": 77906,
	"./guides/lora/app-webhooksite.png": 27993,
	"./guides/lora/gateway/blues-lora-data-flow.png": 31178,
	"./guides/lora/gateway/gateway-blue-pulse.jpg": 73070,
	"./guides/lora/gateway/gateway-dashboard.png": 27530,
	"./guides/lora/gateway/gateway-ethernet-port.jpg": 87274,
	"./guides/lora/gateway/gateway-gweui-highlight.jpg": 1064,
	"./guides/lora/gateway/gateway-gweui.jpg": 31087,
	"./guides/lora/gateway/gateway-interfaces.png": 85020,
	"./guides/lora/gateway/gateway-login.png": 65309,
	"./guides/lora/gateway/gateway-user-settings.png": 17879,
	"./guides/lora/gateway/gateway-wifi.png": 58093,
	"./guides/lora/gateway/non-blues-lora-data-flow.png": 38184,
	"./guides/lora/lora-datacake-another-device.png": 99474,
	"./guides/notecard-guides/attn-pin-behavior.png": 33966,
	"./guides/notecard-guides/attn-wiring.jpg": 15,
	"./guides/notecard-guides/data-sim-usage.png": 93310,
	"./guides/notecard-guides/env-delete.png": 28086,
	"./guides/notecard-guides/env-vars-viz.jpg": 84140,
	"./guides/notecard-guides/env-vars-vizualization.jpg": 51267,
	"./guides/notecard-guides/geolocate-notes.png": 73557,
	"./guides/notecard-guides/jsonata/collect-event-json.gif": 19547,
	"./guides/notecard-guides/jsonata/conditional.png": 85189,
	"./guides/notecard-guides/jsonata/doNotRoute.png": 37136,
	"./guides/notecard-guides/jsonata/jsonata-math.png": 23150,
	"./guides/notecard-guides/jsonata/jsonata-merge.png": 42766,
	"./guides/notecard-guides/jsonata/jsonata-millis.png": 56599,
	"./guides/notecard-guides/jsonata/jsonata-notehub-route.png": 15557,
	"./guides/notecard-guides/jsonata/jsonata-round.png": 50756,
	"./guides/notecard-guides/jsonata/jsonata-simple-2.png": 61249,
	"./guides/notecard-guides/jsonata/jsonata-simple-3.png": 11177,
	"./guides/notecard-guides/jsonata/jsonata-simple.png": 42817,
	"./guides/notecard-guides/jsonata/jsonata.png": 88792,
	"./guides/notecard-guides/jsonata/split-output.png": 64265,
	"./guides/notecard-guides/jsonata/temperature-example.png": 84308,
	"./guides/notecard-guides/notecard-notehub-communication.png": 15756,
	"./guides/notecard-guides/notehub-device-details.png": 27355,
	"./guides/notecard-guides/notehub-device-env.png": 508,
	"./guides/notecard-guides/notehub-fleet-env.png": 73849,
	"./guides/notecard-guides/notehub-fleet-settings.png": 43586,
	"./guides/notecard-guides/notehub-project-env.png": 23671,
	"./guides/notecard-guides/notehub-proxy-route-alias.png": 67208,
	"./guides/notecard-guides/notehub-proxy-route.png": 85671,
	"./guides/notecard-guides/notehub-triangulation.png": 99207,
	"./guides/notecard-guides/notehub-upload-envvar.png": 38885,
	"./guides/notecard-guides/serial-over-i2c/bytes-available.png": 33856,
	"./guides/notecard-guides/serial-over-i2c/no-bytes-available.png": 54875,
	"./guides/notecard-guides/serial-over-i2c/read-bytes.png": 75661,
	"./guides/notecard-guides/serial-over-i2c/write-hello.png": 21135,
	"./guides/notecard-guides/serial-over-i2c/write-world.png": 68127,
	"./guides/notecard-guides/wifi/access-points.png": 10754,
	"./guides/notecard-guides/wifi/black-button-v2.jpg": 31213,
	"./guides/notecard-guides/wifi/black-button.jpg": 8369,
	"./guides/notecard-guides/wifi/connection-screen.png": 35059,
	"./guides/notecard-guides/wifi/wifi-led-v2.jpg": 11987,
	"./guides/notecard-guides/wifi/wifi-led.jpg": 84977,
	"./guides/notecard-walkthrough/LORA.png": 93415,
	"./guides/notecard-walkthrough/MBGLN.png": 35206,
	"./guides/notecard-walkthrough/MBNAN.png": 21402,
	"./guides/notecard-walkthrough/NB.png": 72399,
	"./guides/notecard-walkthrough/NBGLW.png": 97357,
	"./guides/notecard-walkthrough/NBNAW.png": 82734,
	"./guides/notecard-walkthrough/NB_WAVE3.png": 58723,
	"./guides/notecard-walkthrough/WB.png": 10346,
	"./guides/notecard-walkthrough/WBEXW.png": 95125,
	"./guides/notecard-walkthrough/WBGLW.png": 6984,
	"./guides/notecard-walkthrough/WBNAW.png": 85630,
	"./guides/notecard-walkthrough/WB_WAVE3.png": 46491,
	"./guides/notecard-walkthrough/WIFI.png": 97244,
	"./guides/notecard-walkthrough/WIFIv2.png": 29276,
	"./guides/notecard-walkthrough/XP.png": 53043,
	"./guides/notecard-walkthrough/carr-a-low-power.jpg": 58341,
	"./guides/notecard-walkthrough/carr-f-low-power.jpg": 14071,
	"./guides/notehub-api/curl-add-device-to-fleet.png": 23424,
	"./guides/notehub-api/curl-auth.png": 69091,
	"./guides/notehub-api/curl-create-fleet.png": 64542,
	"./guides/notehub-api/curl-devices.png": 54171,
	"./guides/notehub-api/curl-events.png": 91861,
	"./guides/notehub-api/curl-note-add.png": 22879,
	"./guides/notehub-api/notehub-events.png": 29961,
	"./guides/notehub-api/postman-add-device-to-fleet.png": 37024,
	"./guides/notehub-api/postman-auth.png": 87475,
	"./guides/notehub-api/postman-create-fleet.png": 56180,
	"./guides/notehub-api/postman-devices.png": 40294,
	"./guides/notehub-api/postman-events.png": 16382,
	"./guides/notehub-api/postman-note-add.png": 52564,
	"./guides/notehub/create-project.png": 18057,
	"./guides/notehub/events.png": 69984,
	"./guides/notehub/new-device.png": 22466,
	"./guides/notehub/product-uid.png": 82888,
	"./guides/outboard-dfu/apply-host-firmware.png": 60389,
	"./guides/outboard-dfu/arduino-binary-fs.png": 56693,
	"./guides/outboard-dfu/arduino-binary.png": 879,
	"./guides/outboard-dfu/firmware-progress.png": 43369,
	"./guides/outboard-dfu/host-firmware-tab.png": 76273,
	"./guides/outboard-dfu/host-firmware-version.png": 89148,
	"./guides/outboard-dfu/platformio-firmware.png": 43905,
	"./guides/outboard-dfu/upload-firmware-button.png": 9508,
	"./guides/outboard-dfu/uploading-firmware.png": 49444,
	"./guides/route-guides/azure-func-200.png": 14583,
	"./guides/route-guides/azure-func-failed-route.png": 39659,
	"./guides/route-guides/azure-func-options.png": 87258,
	"./guides/route-guides/azure-option.png": 59335,
	"./guides/route-guides/events-screen.png": 54950,
	"./guides/route-guides/failed-route.png": 76170,
	"./guides/route-guides/mosquitto-pub.png": 29687,
	"./guides/route-guides/mqtt-options.png": 89884,
	"./guides/route-guides/mqtt-selection.png": 38409,
	"./guides/route-guides/notecard-web-console-button.png": 75555,
	"./guides/route-guides/notehub-add-route.png": 65622,
	"./guides/route-guides/notehub-twilio-error.png": 94455,
	"./guides/route-guides/notehub-twilio-events.png": 81381,
	"./guides/route-guides/notehub-twilio-route-error.png": 7716,
	"./guides/route-guides/notehub-twilio-route-log.png": 2696,
	"./guides/route-guides/notehub-twilio-route.png": 52442,
	"./guides/route-guides/notehub-twilio-route2.png": 55197,
	"./guides/route-guides/route-log.png": 19482,
	"./guides/route-guides/sms-note.jpg": 45249,
	"./guides/route-guides/successful-route.png": 3977,
	"./guides/route-guides/thingworx-200.png": 96634,
	"./guides/route-guides/thingworx-dashboard.png": 7254,
	"./guides/route-guides/thingworx-failed-route.png": 66937,
	"./guides/route-guides/thingworx-options.png": 70651,
	"./guides/route-guides/thingworx-properties.png": 19023,
	"./guides/route-guides/thingworx-service.png": 32059,
	"./guides/route-guides/twilio-account-credentials.gif": 25975,
	"./guides/route-guides/twilio-filtering.png": 85951,
	"./guides/route-guides/twilio-placeholders.png": 68454,
	"./guides/route-guides/twilio-programmable-messaging-dashboard.png": 11093,
	"./guides/route-guides/twilio-route-config.png": 8700,
	"./guides/route-guides/twilio-route-name.png": 51010,
	"./guides/route-guides/twilio-route.png": 25742,
	"./guides/route-guides/twilio-trial-number.png": 12384,
	"./guides/route-guides/twilio-verified-caller-ids.png": 51738,
	"./guides/route-guides/webhook-site-request.png": 78272,
	"./guides/route-guides/webhook-site.png": 34807,
	"./guides/route-tutorial/add-fields.png": 94556,
	"./guides/route-tutorial/add-route.png": 35667,
	"./guides/route-tutorial/add-widget.png": 54229,
	"./guides/route-tutorial/api-keys.png": 70180,
	"./guides/route-tutorial/aws/analytics-dataset-listing.png": 95107,
	"./guides/route-tutorial/aws/analytics-dataset-result-preview.png": 13773,
	"./guides/route-tutorial/aws/analytics-dataset-run-now.png": 18982,
	"./guides/route-tutorial/aws/analytics-datasets.png": 82950,
	"./guides/route-tutorial/aws/analytics-pipeline-activities-edit.png": 91027,
	"./guides/route-tutorial/aws/analytics-pipeline-activity-select.png": 30546,
	"./guides/route-tutorial/aws/analytics-pipeline-add-activity.png": 80329,
	"./guides/route-tutorial/aws/analytics-pipeline-field-select.png": 11236,
	"./guides/route-tutorial/aws/analytics-pipeline-inference.png": 68392,
	"./guides/route-tutorial/aws/analytics-pipeline-listing.png": 51065,
	"./guides/route-tutorial/aws/analytics-pipeline-reprocess.png": 92270,
	"./guides/route-tutorial/aws/analytics-pipeline-sel-msg-attr.png": 44794,
	"./guides/route-tutorial/aws/analytics-pipelines.png": 17392,
	"./guides/route-tutorial/aws/analytics-quick-create.png": 17049,
	"./guides/route-tutorial/aws/analytics-request-syntax.png": 48551,
	"./guides/route-tutorial/aws/analytics-resources.png": 62950,
	"./guides/route-tutorial/aws/iam-home.png": 30435,
	"./guides/route-tutorial/aws/iam-user-access-key-created.png": 42391,
	"./guides/route-tutorial/aws/iam-user-access-key-description.png": 11999,
	"./guides/route-tutorial/aws/iam-user-access-key-usecase.png": 31174,
	"./guides/route-tutorial/aws/iam-user-create-access-key.png": 35630,
	"./guides/route-tutorial/aws/iam-user-security-credentials.png": 97315,
	"./guides/route-tutorial/aws/iam-users-new-user.png": 84056,
	"./guides/route-tutorial/aws/iam-users-policy.png": 54664,
	"./guides/route-tutorial/aws/iam-users-review.png": 23173,
	"./guides/route-tutorial/aws/iam-users-success.png": 10474,
	"./guides/route-tutorial/aws/iam-users.png": 14824,
	"./guides/route-tutorial/aws/quicksight-analysis-autograph.png": 81076,
	"./guides/route-tutorial/aws/quicksight-analysis-average.png": 1288,
	"./guides/route-tutorial/aws/quicksight-analysis-duplicate.png": 11080,
	"./guides/route-tutorial/aws/quicksight-analysis-gauge-chart.png": 82612,
	"./guides/route-tutorial/aws/quicksight-analysis-linechart-make.png": 53593,
	"./guides/route-tutorial/aws/quicksight-analysis-linechart-x-agg.png": 19905,
	"./guides/route-tutorial/aws/quicksight-analysis-linechart.png": 88261,
	"./guides/route-tutorial/aws/quicksight-configure.png": 20274,
	"./guides/route-tutorial/aws/quicksight-dashboard-complete.png": 80954,
	"./guides/route-tutorial/aws/quicksight-datasets-analytics.png": 53237,
	"./guides/route-tutorial/aws/quicksight-datasets-finish.png": 73823,
	"./guides/route-tutorial/aws/quicksight-datasets-select.png": 44183,
	"./guides/route-tutorial/aws/quicksight-new-analysis.png": 6020,
	"./guides/route-tutorial/aws/quicksight-new-dataset.png": 71994,
	"./guides/route-tutorial/aws/quicksight-signup.png": 62798,
	"./guides/route-tutorial/aws/quicksight-standard-plan.png": 84693,
	"./guides/route-tutorial/aws/route-aws-config.png": 14302,
	"./guides/route-tutorial/aws/route-log.png": 58809,
	"./guides/route-tutorial/aws/route-type-select.png": 36537,
	"./guides/route-tutorial/aws/select-aws.png": 80412,
	"./guides/route-tutorial/azure/add-capability.png": 8038,
	"./guides/route-tutorial/azure/add-interface.png": 13109,
	"./guides/route-tutorial/azure/add-tile.png": 80549,
	"./guides/route-tutorial/azure/all-devices.png": 11058,
	"./guides/route-tutorial/azure/capability-model-create.png": 76929,
	"./guides/route-tutorial/azure/console.png": 36242,
	"./guides/route-tutorial/azure/custom-interface.png": 32016,
	"./guides/route-tutorial/azure/dashboard-name.png": 59560,
	"./guides/route-tutorial/azure/deployment-complete.png": 74708,
	"./guides/route-tutorial/azure/deployment-config.png": 82328,
	"./guides/route-tutorial/azure/deployment-in-progress.png": 42916,
	"./guides/route-tutorial/azure/deployment-underway.png": 74287,
	"./guides/route-tutorial/azure/device-bridge-github.png": 18388,
	"./guides/route-tutorial/azure/edit-chart.png": 1377,
	"./guides/route-tutorial/azure/edit-dashboard.png": 5198,
	"./guides/route-tutorial/azure/final-chart.png": 67871,
	"./guides/route-tutorial/azure/final-dashboard.png": 21587,
	"./guides/route-tutorial/azure/function-app.png": 18690,
	"./guides/route-tutorial/azure/function-url.png": 11069,
	"./guides/route-tutorial/azure/hu-telemetry.png": 48856,
	"./guides/route-tutorial/azure/increase-size.png": 27442,
	"./guides/route-tutorial/azure/iot-device-template.png": 5424,
	"./guides/route-tutorial/azure/iotc-config.png": 97091,
	"./guides/route-tutorial/azure/iotc-dashboard.png": 16308,
	"./guides/route-tutorial/azure/iotc-url.png": 33231,
	"./guides/route-tutorial/azure/last-humidity.png": 35948,
	"./guides/route-tutorial/azure/last-known-value-change.png": 72352,
	"./guides/route-tutorial/azure/last-known-value.png": 33586,
	"./guides/route-tutorial/azure/last-temp.png": 32625,
	"./guides/route-tutorial/azure/middleware-create.png": 43737,
	"./guides/route-tutorial/azure/migrate-confirm.png": 10087,
	"./guides/route-tutorial/azure/migrate.png": 65389,
	"./guides/route-tutorial/azure/new-dashboard.png": 53005,
	"./guides/route-tutorial/azure/new-iot-central.png": 36241,
	"./guides/route-tutorial/azure/paste-function-url.png": 75152,
	"./guides/route-tutorial/azure/portal.png": 9032,
	"./guides/route-tutorial/azure/publish-confirm.png": 64784,
	"./guides/route-tutorial/azure/publish-template.png": 10362,
	"./guides/route-tutorial/azure/raw-data.png": 92422,
	"./guides/route-tutorial/azure/restart-app.png": 6135,
	"./guides/route-tutorial/azure/route-log.png": 77464,
	"./guides/route-tutorial/azure/sas-token.png": 43112,
	"./guides/route-tutorial/azure/scope-id.png": 51716,
	"./guides/route-tutorial/azure/select-azure.png": 2034,
	"./guides/route-tutorial/azure/select-device.png": 62575,
	"./guides/route-tutorial/azure/select-temp.png": 15148,
	"./guides/route-tutorial/azure/simple-tile.png": 75801,
	"./guides/route-tutorial/azure/temp-telemetry.png": 36882,
	"./guides/route-tutorial/azure/template-create.png": 2256,
	"./guides/route-tutorial/azure/template-name.png": 99594,
	"./guides/route-tutorial/channel-dashboard.png": 87084,
	"./guides/route-tutorial/create-channel.png": 15757,
	"./guides/route-tutorial/datacake/datacake-account.png": 30470,
	"./guides/route-tutorial/datacake/datacake-add-field.png": 57931,
	"./guides/route-tutorial/datacake/datacake-add-widget.png": 17767,
	"./guides/route-tutorial/datacake/datacake-all-fields.png": 73486,
	"./guides/route-tutorial/datacake/datacake-api-config.png": 27990,
	"./guides/route-tutorial/datacake/datacake-api-device.png": 32840,
	"./guides/route-tutorial/datacake/datacake-complete-dashboard.png": 91121,
	"./guides/route-tutorial/datacake/datacake-dashboard-field.png": 22683,
	"./guides/route-tutorial/datacake/datacake-device-config.png": 14646,
	"./guides/route-tutorial/datacake/datacake-endpoint.png": 70219,
	"./guides/route-tutorial/datacake/datacake-existing-temp.png": 22631,
	"./guides/route-tutorial/datacake/datacake-new-device.png": 73944,
	"./guides/route-tutorial/datacake/datacake-notecard-device.png": 89779,
	"./guides/route-tutorial/datacake/datacake-notehub-deviceuid.png": 93847,
	"./guides/route-tutorial/datacake/datacake-plan.png": 56338,
	"./guides/route-tutorial/datacake/datacake-route.png": 17546,
	"./guides/route-tutorial/datacake/datacake-temp-copy.png": 2010,
	"./guides/route-tutorial/datacake/datacake-temp.png": 99043,
	"./guides/route-tutorial/datacake/datacake-toggle-dashboard.png": 17912,
	"./guides/route-tutorial/datacake/notehub-add-route.png": 7454,
	"./guides/route-tutorial/events-view.png": 36997,
	"./guides/route-tutorial/gauge-config.png": 12626,
	"./guides/route-tutorial/gauge-on-dashboard.png": 61267,
	"./guides/route-tutorial/gauge.png": 89661,
	"./guides/route-tutorial/gcp/gcp-add-dataset-table.png": 82810,
	"./guides/route-tutorial/gcp/gcp-add-dataset.png": 56432,
	"./guides/route-tutorial/gcp/gcp-add-route.png": 40018,
	"./guides/route-tutorial/gcp/gcp-cloud-function.png": 19939,
	"./guides/route-tutorial/gcp/gcp-cloud-shell.png": 63950,
	"./guides/route-tutorial/gcp/gcp-create-bucket.png": 94349,
	"./guides/route-tutorial/gcp/gcp-create-project.png": 24475,
	"./guides/route-tutorial/gcp/gcp-data-studio-bar-complete.png": 8997,
	"./guides/route-tutorial/gcp/gcp-data-studio-bar.png": 7931,
	"./guides/route-tutorial/gcp/gcp-data-studio-blank.png": 31259,
	"./guides/route-tutorial/gcp/gcp-data-studio-dashboard.png": 26834,
	"./guides/route-tutorial/gcp/gcp-function-permissions.png": 19374,
	"./guides/route-tutorial/gcp/gcp-native-mode.png": 66039,
	"./guides/route-tutorial/gcp/gcp-new-collection.png": 89315,
	"./guides/route-tutorial/gcp/gcp-new-function.png": 39095,
	"./guides/route-tutorial/gcp/gcp-permissions-add.png": 35007,
	"./guides/route-tutorial/gcp/gcp-route-config-final.png": 63078,
	"./guides/route-tutorial/gcp/gcp-route-config.png": 65965,
	"./guides/route-tutorial/gcp/gcp-scorecard-max.png": 10033,
	"./guides/route-tutorial/gcp/gcp-test-function.png": 41162,
	"./guides/route-tutorial/gcp/gcp-view-data.png": 17518,
	"./guides/route-tutorial/gcp/select-google.png": 11074,
	"./guides/route-tutorial/general-http-https/notehub-edit-route-url.png": 30359,
	"./guides/route-tutorial/general-http-https/notehub-route-view-button.png": 54910,
	"./guides/route-tutorial/general-http-request.png": 24872,
	"./guides/route-tutorial/general-route.png": 24961,
	"./guides/route-tutorial/initial-state/access-key.png": 28629,
	"./guides/route-tutorial/initial-state/bucket-key.png": 30058,
	"./guides/route-tutorial/initial-state/bucket-list.png": 31203,
	"./guides/route-tutorial/initial-state/data-flowing.png": 17684,
	"./guides/route-tutorial/initial-state/edit-tiles.png": 87898,
	"./guides/route-tutorial/initial-state/final-dashboard.png": 56768,
	"./guides/route-tutorial/initial-state/gauge-config.png": 30476,
	"./guides/route-tutorial/initial-state/headers.png": 98107,
	"./guides/route-tutorial/initial-state/headers2.png": 35815,
	"./guides/route-tutorial/initial-state/humidity-edit.png": 21002,
	"./guides/route-tutorial/initial-state/initial-state-home.png": 41589,
	"./guides/route-tutorial/initial-state/manage-settings.png": 13047,
	"./guides/route-tutorial/initial-state/move-tile.png": 91012,
	"./guides/route-tutorial/initial-state/new-bucket.png": 46351,
	"./guides/route-tutorial/initial-state/new-tile.png": 46621,
	"./guides/route-tutorial/initial-state/route-settings.png": 69045,
	"./guides/route-tutorial/initial-state/route-settings2.png": 30770,
	"./guides/route-tutorial/initial-state/temp-edit.png": 85838,
	"./guides/route-tutorial/initial-state/tile-modal.png": 16228,
	"./guides/route-tutorial/initial-state/tile-type.png": 51907,
	"./guides/route-tutorial/jsonata-expression.png": 5257,
	"./guides/route-tutorial/jsonata-myjson-live.png": 75669,
	"./guides/route-tutorial/jsonata.png": 52649,
	"./guides/route-tutorial/pencil-icon.png": 9786,
	"./guides/route-tutorial/route-logos/logo_aws.png": 79482,
	"./guides/route-tutorial/route-logos/logo_azure.png": 5950,
	"./guides/route-tutorial/route-logos/logo_datacake.png": 87683,
	"./guides/route-tutorial/route-logos/logo_edgeimpulse.png": 41481,
	"./guides/route-tutorial/route-logos/logo_google-cloud.png": 64070,
	"./guides/route-tutorial/route-logos/logo_https-request.png": 62737,
	"./guides/route-tutorial/route-logos/logo_mqtt.png": 34900,
	"./guides/route-tutorial/route-logos/logo_proxy.png": 16970,
	"./guides/route-tutorial/route-logos/logo_radresponder.png": 26883,
	"./guides/route-tutorial/route-logos/logo_s3.png": 3546,
	"./guides/route-tutorial/route-logos/logo_slack.png": 91111,
	"./guides/route-tutorial/route-logos/logo_snowflake.png": 18472,
	"./guides/route-tutorial/route-logos/logo_thingworx.png": 62479,
	"./guides/route-tutorial/route-logos/logo_twilio.png": 46683,
	"./guides/route-tutorial/route-name.png": 63075,
	"./guides/route-tutorial/route-url.png": 76881,
	"./guides/route-tutorial/routes-screen.png": 89797,
	"./guides/route-tutorial/save-route.png": 44791,
	"./guides/route-tutorial/select-notefiles.png": 67230,
	"./guides/route-tutorial/sensors-qo.png": 21626,
	"./guides/route-tutorial/snowflake/desc_user.png": 44309,
	"./guides/route-tutorial/snowflake/json-rows.png": 94988,
	"./guides/route-tutorial/snowflake/line-chart.png": 27452,
	"./guides/route-tutorial/snowflake/map.png": 97878,
	"./guides/route-tutorial/snowflake/org-name.png": 20759,
	"./guides/route-tutorial/snowflake/route-config.png": 71973,
	"./guides/route-tutorial/snowflake/route-status.png": 7627,
	"./guides/route-tutorial/snowflake/select-notefiles.png": 71689,
	"./guides/route-tutorial/snowflake/snowflake-route.png": 71969,
	"./guides/route-tutorial/snowflake/snowflake-trial.png": 6983,
	"./guides/route-tutorial/snowflake/streamlit-rerun.png": 35023,
	"./guides/route-tutorial/snowflake/streamlit-skeleton.png": 10876,
	"./guides/route-tutorial/snowflake/streamlit-table.png": 14137,
	"./guides/route-tutorial/snowflake/view-results.png": 84563,
	"./guides/route-tutorial/thiingspeak.png": 32336,
	"./guides/route-tutorial/thingspeak-account.png": 79146,
	"./guides/route-tutorial/thingspeak-add-route.png": 88731,
	"./guides/route-tutorial/thingspeak-dashboard-with-data.png": 4639,
	"./guides/route-tutorial/thingspeak-route.png": 17152,
	"./guides/route-tutorial/ubidots/ubidots-account.png": 23147,
	"./guides/route-tutorial/ubidots/ubidots-add-histogram.png": 71701,
	"./guides/route-tutorial/ubidots/ubidots-add-thermometer.png": 50114,
	"./guides/route-tutorial/ubidots/ubidots-auth-token.png": 50426,
	"./guides/route-tutorial/ubidots/ubidots-create-device.png": 13327,
	"./guides/route-tutorial/ubidots/ubidots-data-viz.png": 79030,
	"./guides/route-tutorial/ubidots/ubidots-default-token.png": 65276,
	"./guides/route-tutorial/ubidots/ubidots-device-label.png": 98623,
	"./guides/route-tutorial/ubidots/ubidots-full-dashboard.png": 6008,
	"./guides/route-tutorial/ubidots/ubidots-histogram-temp.png": 56925,
	"./guides/route-tutorial/ubidots/ubidots-histogram.png": 96313,
	"./guides/route-tutorial/ubidots/ubidots-route-config.png": 61788,
	"./guides/route-tutorial/ubidots/ubidots-therm-aggregation.png": 67129,
	"./guides/route-tutorial/webhook-site-data.png": 89611,
	"./guides/route-tutorial/webhook-site-jsonata.png": 76631,
	"./guides/route-tutorial/webhook-site-url.png": 36547,
	"./guides/swan-edge-impulse/accel-library.png": 63791,
	"./guides/swan-edge-impulse/accel.png": 5798,
	"./guides/swan-edge-impulse/add-library-platformio.png": 80389,
	"./guides/swan-edge-impulse/add-library.png": 67975,
	"./guides/swan-edge-impulse/arduino-example.png": 8158,
	"./guides/swan-edge-impulse/captured-data.png": 94866,
	"./guides/swan-edge-impulse/chop.png": 18309,
	"./guides/swan-edge-impulse/data-stream.png": 30988,
	"./guides/swan-edge-impulse/design-impulse.png": 6982,
	"./guides/swan-edge-impulse/download-arduino.png": 13209,
	"./guides/swan-edge-impulse/download-confirm.png": 29820,
	"./guides/swan-edge-impulse/download-model.png": 95322,
	"./guides/swan-edge-impulse/edge-impulse-data-forwarder.png": 72132,
	"./guides/swan-edge-impulse/ei-capture.png": 59104,
	"./guides/swan-edge-impulse/ei-terminal.png": 325,
	"./guides/swan-edge-impulse/example-dashboard.png": 23375,
	"./guides/swan-edge-impulse/features.png": 36767,
	"./guides/swan-edge-impulse/inference-monitor.png": 94962,
	"./guides/swan-edge-impulse/keras.png": 73994,
	"./guides/swan-edge-impulse/live-classify.png": 16550,
	"./guides/swan-edge-impulse/live-test-wave.png": 38746,
	"./guides/swan-edge-impulse/model-testing.png": 48703,
	"./guides/swan-edge-impulse/product-uid-location.png": 56937,
	"./guides/swan-edge-impulse/spectral.png": 86274,
	"./guides/swan-edge-impulse/test-data.png": 20459,
	"./guides/swan-edge-impulse/time-series.png": 28641,
	"./guides/swan-edge-impulse/training-complete.png": 77288,
	"./guides/swan-edge-impulse/training-in-progress.png": 75746,
	"./guides/zzz-test/curiosity.jpg": 95926,
	"./hardware/airnote/all-sides-v2.png": 40210,
	"./hardware/airnote/all-sides.jpg": 13017,
	"./hardware/airnote/hardware-block-diagram-v2.png": 83153,
	"./hardware/airnote/hardware-block-diagram.png": 22558,
	"./hardware/airnote/lcd-54321.png": 24850,
	"./hardware/airnote/lcd-init.png": 3673,
	"./hardware/airnote/lcd-kpa.png": 12585,
	"./hardware/airnote/lcd-rh.png": 20379,
	"./hardware/airnote/lcd-temperature.png": 24845,
	"./hardware/airnote/lcd-test.png": 76644,
	"./hardware/airnote/lcd-volts.png": 60537,
	"./hardware/design.svg": 56790,
	"./hardware/hookup/a-1.jpg": 72054,
	"./hardware/hookup/a-2.jpg": 997,
	"./hardware/hookup/a-3.jpg": 13533,
	"./hardware/hookup/a-4.jpg": 1922,
	"./hardware/hookup/a-5.jpg": 54754,
	"./hardware/hookup/carr-b-1.jpg": 9842,
	"./hardware/hookup/carr-b-2.jpg": 33342,
	"./hardware/hookup/carr-b-3.jpg": 60132,
	"./hardware/hookup/carr-b-4.jpg": 32726,
	"./hardware/hookup/carr-b-5.jpg": 82095,
	"./hardware/hookup/carr-f-1.jpg": 76184,
	"./hardware/hookup/carr-f-2.jpg": 83364,
	"./hardware/hookup/carr-f-3.jpg": 75753,
	"./hardware/hookup/carr-f-4.jpg": 96018,
	"./hardware/hookup/carr-f-5.jpg": 86979,
	"./hardware/hookup/carr-r-1.jpg": 53792,
	"./hardware/hookup/carr-r-2.jpg": 96483,
	"./hardware/hookup/carr-r-3.jpg": 32522,
	"./hardware/hookup/carr-r-4.jpg": 77728,
	"./hardware/hookup/carr-r-5.jpg": 82696,
	"./hardware/hookup/lora-1.png": 90533,
	"./hardware/hookup/lora-2.png": 54000,
	"./hardware/hookup/lora-3.png": 75210,
	"./hardware/hookup/lora-4.png": 33462,
	"./hardware/hookup/lora-5.png": 5665,
	"./hardware/hookup/lora-6.png": 59326,
	"./hardware/hookup/pi-1.jpg": 10453,
	"./hardware/hookup/pi-2.jpg": 21897,
	"./hardware/hookup/pi-3.jpg": 82833,
	"./hardware/hookup/pi-4.jpg": 81223,
	"./hardware/hookup/pi-5.jpg": 48441,
	"./hardware/hookup/sparkfun-1.png": 48684,
	"./hardware/hookup/sparkfun-2.png": 96818,
	"./hardware/hookup/sparkfun-3.png": 16615,
	"./hardware/hookup/sparkfun-4.png": 79717,
	"./hardware/hookup/sparkfun-5.png": 12536,
	"./hardware/hookup/sparkfun-6.png": 79281,
	"./hardware/hookup/sparkfun-7.png": 25701,
	"./hardware/hookup/sparkfun-8.png": 22147,
	"./hardware/hookup/sparkfun-function-1.jpg": 25490,
	"./hardware/hookup/sparkfun-function-2.jpg": 77221,
	"./hardware/hookup/sparkfun-function-3.jpg": 39663,
	"./hardware/hookup/sparkfun-function-4.jpg": 91058,
	"./hardware/host-system-design-guide/external-mff2-sim.png": 38840,
	"./hardware/host-system-design-guide/external-nano-sim-slot.png": 76822,
	"./hardware/notecard.svg": 26002,
	"./hardware/notecard/ESP-Back.png": 88538,
	"./hardware/notecard/ESP-Front.png": 43280,
	"./hardware/notecard/LORA-Back.png": 42710,
	"./hardware/notecard/LORA-Front.png": 68867,
	"./hardware/notecard/MBGLN-Back.png": 51287,
	"./hardware/notecard/MBGLN-Front.png": 53050,
	"./hardware/notecard/MBGLW-Back.png": 32735,
	"./hardware/notecard/MBGLW-Front.png": 934,
	"./hardware/notecard/MBNAN-Back.png": 76616,
	"./hardware/notecard/MBNAN-Front.png": 51022,
	"./hardware/notecard/MBNAW-Back.png": 23883,
	"./hardware/notecard/MBNAW-Front.png": 13973,
	"./hardware/notecard/NBGLN-Back.png": 227,
	"./hardware/notecard/NBGLN-Front.png": 91125,
	"./hardware/notecard/NBGLW-Back.png": 38527,
	"./hardware/notecard/NBGLW-Front.png": 15031,
	"./hardware/notecard/NBNAN-Back.png": 80024,
	"./hardware/notecard/NBNAN-Front.png": 21851,
	"./hardware/notecard/NBNAW-Back.png": 37531,
	"./hardware/notecard/NBNAW-Front.png": 55991,
	"./hardware/notecard/WBEXN-Back.png": 49861,
	"./hardware/notecard/WBEXN-Front.png": 89344,
	"./hardware/notecard/WBEXW-Back.png": 96952,
	"./hardware/notecard/WBEXW-Front.png": 79571,
	"./hardware/notecard/WBGLW-Back.png": 75494,
	"./hardware/notecard/WBGLW-Front.png": 45382,
	"./hardware/notecard/WBNAN-Back.png": 23816,
	"./hardware/notecard/WBNAN-Front.png": 4181,
	"./hardware/notecard/WBNAW-Back.png": 7266,
	"./hardware/notecard/WBNAW-Front.png": 53452,
	"./hardware/notecard/XP-Generic.png": 24567,
	"./hardware/notecard/note_wifi.png": 24643,
	"./hardware/notecard/notecard-narrowband.jpg": 94935,
	"./hardware/notecard/notecard-wideband.jpg": 57589,
	"./hardware/notecard/notecard-wifi.jpg": 98707,
	"./hardware/notecard/typical-application.png": 9120,
	"./hardware/notecarrier.svg": 53166,
	"./hardware/notecarrier/CARR_AA_back.jpg": 22479,
	"./hardware/notecarrier/CARR_AA_front.jpg": 55908,
	"./hardware/notecarrier/CARR_AE_back.jpg": 84350,
	"./hardware/notecarrier/CARR_AE_front.jpg": 60746,
	"./hardware/notecarrier/CARR_AF_front.jpg": 45712,
	"./hardware/notecarrier/CARR_AL_back.jpg": 19192,
	"./hardware/notecarrier/CARR_AL_front.jpg": 59609,
	"./hardware/notecarrier/CARR_AL_front.png": 52265,
	"./hardware/notecarrier/CARR_A_back.jpg": 46548,
	"./hardware/notecarrier/CARR_A_front.jpg": 29996,
	"./hardware/notecarrier/CARR_B_10_back.jpg": 35164,
	"./hardware/notecarrier/CARR_B_10_front.jpg": 81735,
	"./hardware/notecarrier/CARR_B_21_back.jpg": 78927,
	"./hardware/notecarrier/CARR_B_21_front.jpg": 87443,
	"./hardware/notecarrier/CARR_B_31_back.jpg": 1213,
	"./hardware/notecarrier/CARR_B_31_front.jpg": 25046,
	"./hardware/notecarrier/CARR_F_13_back.png": 11803,
	"./hardware/notecarrier/CARR_F_13_front.png": 249,
	"./hardware/notecarrier/CARR_F_back.png": 77472,
	"./hardware/notecarrier/CARR_F_front.png": 33891,
	"./hardware/notecarrier/CARR_PI_2_back.png": 30274,
	"./hardware/notecarrier/CARR_PI_2_front.png": 91227,
	"./hardware/notecarrier/CARR_PI_back.jpg": 5450,
	"./hardware/notecarrier/CARR_PI_front.jpg": 97976,
	"./hardware/notecarrier/CARR_R_10_back.png": 64822,
	"./hardware/notecarrier/CARR_R_10_front.png": 65876,
	"./hardware/notecarrier/f-1-3-dips.png": 68782,
	"./hardware/notecarrier/f-dips.png": 76361,
	"./hardware/notecarrier/pi-dips.png": 18493,
	"./hardware/scoop/scoop-back-v1.png": 49285,
	"./hardware/scoop/scoop-front-v1.png": 96907,
	"./hardware/sparrow/cortex-connector-reference-sensor.png": 10883,
	"./hardware/sparrow/dip-switch-schematic.png": 31518,
	"./hardware/sparrow/sparrow-back-iso.png": 50381,
	"./hardware/sparrow/sparrow-essentials.png": 94216,
	"./hardware/sparrow/sparrow-gateway.png": 54095,
	"./hardware/sparrow/sparrow-iso.png": 69488,
	"./hardware/sparrow/sparrow-reference-sensor-node.png": 7764,
	"./hardware/sparrow/sparrow.png": 10273,
	"./hardware/starnote/starnote-ignion-back.png": 44252,
	"./hardware/starnote/starnote-ignion-front.png": 64424,
	"./hardware/starnote/starnote-ufl-back.png": 50945,
	"./hardware/starnote/starnote-ufl-front.png": 87790,
	"./hardware/starter-kits/lorawan-starter-kit-small.jpg": 39927,
	"./hardware/starter-kits/lorawan-starter-kit.jpg": 44552,
	"./hardware/starter-kits/notecarrier-f-swan-kit.png": 57527,
	"./hardware/starter-kits/notecarrier_af_kit.png": 24763,
	"./hardware/starter-kits/temp-starnote-kit.png": 14474,
	"./hardware/swan/swan-iso-15.png": 47667,
	"./hardware/swan/swan-iso-30-small.png": 99624,
	"./hardware/swan/swan-iso-30.png": 64666,
	"./hardware/swan/swan-iso-small.png": 63044,
	"./hardware/swan/swan-iso.png": 98375,
	"./hardware/swan/swan-pinout-carrier-v1.5.png": 4483,
	"./hardware/swan/swan-pinout-carrier-v1.7.png": 12637,
	"./hardware/swan/swan-pinout-carrier-v3.0.png": 39901,
	"./hardware/swan/swan-pinout-embedded-v1.5.png": 18615,
	"./hardware/swan/swan-pinout-embedded-v1.7.png": 79629,
	"./hardware/swan/swan-pinout-embedded-v3.0.png": 79239,
	"./hardware/swan/swan-pinout-feather-v1.5.png": 23092,
	"./hardware/swan/swan-pinout-feather-v1.7.png": 41788,
	"./hardware/swan/swan-pinout-feather-v3.0.png": 45027,
	"./hardware/swan/swan.png": 94042,
	"./home/accelerators-icon.svg": 68177,
	"./home/background-noise.webp": 17773,
	"./home/blog-icon.svg": 2936,
	"./home/datasheets-icon.svg": 72987,
	"./home/docs-icon.svg": 83101,
	"./home/started-icon.svg": 17105,
	"./icons/1.svg": 681,
	"./icons/2.svg": 66355,
	"./icons/3.svg": 57092,
	"./icons/account_circle-white.svg": 78730,
	"./icons/arrow-left.svg": 48728,
	"./icons/arrow-right-14px-mutedBlue.svg": 31371,
	"./icons/arrow-right.svg": 22679,
	"./icons/arrow.svg": 56165,
	"./icons/benefits.svg": 2964,
	"./icons/callout-note.svg": 89404,
	"./icons/callout-success.svg": 55935,
	"./icons/callout-warning.svg": 2178,
	"./icons/chat.svg": 66538,
	"./icons/curved-arrow.svg": 29400,
	"./icons/docs/cloud.svg": 64731,
	"./icons/docs/firmware-libraries.svg": 18127,
	"./icons/docs/library-books.svg": 61993,
	"./icons/docs/notecard-guides.svg": 50805,
	"./icons/docs/notecard-solutions.svg": 51500,
	"./icons/docs/notehub-guides.svg": 15835,
	"./icons/docs/precision-manufacturing.svg": 6393,
	"./icons/docs/reference.svg": 97870,
	"./icons/docs/send-to-mobile.svg": 35467,
	"./icons/docs/sensors.svg": 3181,
	"./icons/feedback.svg": 11361,
	"./icons/launch.svg": 74413,
	"./icons/nav/arrow-back.svg": 38571,
	"./icons/nav/chevron_left.svg": 31562,
	"./icons/requirements.svg": 43681,
	"./icons/support_white.svg": 92728,
	"./icons/terminal.svg": 91513,
	"./icons/thumbs-up.svg": 86509,
	"./icons/training.svg": 30472,
	"./icons/views.svg": 63910,
	"./logo/blues-brandmark-white.svg": 23084,
	"./logo/blues-brandmark.svg": 68539,
	"./logo/blues-logomark-white.svg": 21629,
	"./logo/blues-logomark.svg": 88382,
	"./newsletter/2024-02.png": 20281,
	"./newsletter/2024-03.webp": 54574,
	"./newsletter/2024-04.png": 81466,
	"./notehub/airnote_example.png": 34528,
	"./notehub/alert-all.png": 30764,
	"./notehub/alert-disable-mute.png": 50492,
	"./notehub/alert-log.png": 22115,
	"./notehub/alert-notefile.png": 91135,
	"./notehub/alert-thresholds.png": 60366,
	"./notehub/api-oauth-client.png": 17064,
	"./notehub/api-oauth.png": 70511,
	"./notehub/auto-recharge.png": 92085,
	"./notehub/billing-menu.png": 30264,
	"./notehub/ca-disable-billing-account.png": 33482,
	"./notehub/ca-disable-device.png": 42410,
	"./notehub/ca-disable-project.png": 16090,
	"./notehub/cc-usage.png": 92244,
	"./notehub/clone-project.png": 27760,
	"./notehub/create_project_button.png": 56264,
	"./notehub/create_project_card.png": 24403,
	"./notehub/device_add_fleet.png": 99322,
	"./notehub/device_block.png": 63744,
	"./notehub/device_dashboard_url.png": 87946,
	"./notehub/device_details.png": 46899,
	"./notehub/device_details_environment_tab.png": 78089,
	"./notehub/device_firmware_confirmation.png": 12599,
	"./notehub/device_fleet_edit.png": 35300,
	"./notehub/device_fleet_key_value.png": 75026,
	"./notehub/device_fleet_list.png": 95771,
	"./notehub/device_fleet_menu.png": 73219,
	"./notehub/device_fleet_settings_option.png": 63410,
	"./notehub/device_json.png": 64693,
	"./notehub/device_key_value.png": 19821,
	"./notehub/device_new_fleet.png": 26895,
	"./notehub/device_select.png": 54338,
	"./notehub/device_select_host_fw.png": 97077,
	"./notehub/device_select_notecard_fw.png": 33730,
	"./notehub/device_update.png": 51853,
	"./notehub/edge-impulse/api-key.png": 6134,
	"./notehub/edge-impulse/dataset-files.png": 12091,
	"./notehub/edge-impulse/edge-impulse-data.png": 41591,
	"./notehub/edge-impulse/route-configuration.png": 14534,
	"./notehub/edge-impulse/route-data.png": 92735,
	"./notehub/edge-impulse/route-filters.png": 62064,
	"./notehub/edge-impulse/route-option.png": 76584,
	"./notehub/edge-impulse/sensor-creation.png": 861,
	"./notehub/event_details.png": 1147,
	"./notehub/event_json.png": 17138,
	"./notehub/event_menu.png": 57500,
	"./notehub/event_select.png": 5894,
	"./notehub/favorite_button.png": 79173,
	"./notehub/favorite_list.png": 22589,
	"./notehub/favorite_name.png": 63343,
	"./notehub/firmware_upload_page.png": 13756,
	"./notehub/fleet-device-assign.png": 20041,
	"./notehub/fleet-device-select.png": 35114,
	"./notehub/fleet_menu.png": 11374,
	"./notehub/invite-members.png": 58959,
	"./notehub/link_github.png": 91339,
	"./notehub/notecard_firmware_requested.png": 14012,
	"./notehub/notecard_firmware_select.png": 90298,
	"./notehub/notecard_firmware_status.png": 86482,
	"./notehub/notehub-jsonata-expression.png": 6592,
	"./notehub/notehub_dashboard_link.png": 35122,
	"./notehub/pay-now.png": 49749,
	"./notehub/postman-api-key-secret.png": 80099,
	"./notehub/postman-base-url-variable.png": 3507,
	"./notehub/postman-environment.png": 54683,
	"./notehub/postman-tests.png": 45513,
	"./notehub/prefix-acme.png": 24484,
	"./notehub/prefix-billing-menu.png": 26496,
	"./notehub/prefix-prefixes-tab.png": 55478,
	"./notehub/prefix-request-sent.png": 25074,
	"./notehub/productuid-new-settings.png": 14787,
	"./notehub/productuid-new.png": 64180,
	"./notehub/project_contact.png": 66003,
	"./notehub/purchase-credits.png": 34871,
	"./notehub/route-bulk-retry.png": 45548,
	"./notehub/route-manual-single.png": 14244,
	"./notehub/route-retry-auto.png": 43089,
	"./notehub/s3/access-key.png": 16138,
	"./notehub/s3/route-event.png": 1429,
	"./notehub/s3/route-option.png": 55695,
	"./notehub/s3/route-success.png": 43746,
	"./notehub/s3/s3-data.png": 27522,
	"./notehub/s3/security-credentials.png": 47210,
	"./notehub/select_host_firmware.png": 46928,
	"./notehub/session_json.png": 55501,
	"./notehub/session_option.png": 7216,
	"./notehub/session_select.png": 81113,
	"./notehub/settings_accounts.png": 45364,
	"./notehub/settings_add_members.png": 8393,
	"./notehub/settings_environment_key_value.png": 17710,
	"./notehub/settings_firmware.png": 93915,
	"./notehub/settings_members.png": 96665,
	"./notehub/settings_productuid.png": 21106,
	"./notehub/settings_productuid_alt.png": 7524,
	"./notehub/settings_upload_firmware.png": 80716,
	"./notehub/signin_page_sign_up.png": 18978,
	"./notehub/signup_create_project.png": 51835,
	"./notehub/signup_page.png": 88361,
	"./notehub/slack/app-invite.png": 71020,
	"./notehub/slack/channel-id.png": 91025,
	"./notehub/slack/oauth-token-location.png": 34785,
	"./notehub/slack/route-option.png": 62373,
	"./notehub/slack/slack-message.png": 14296,
	"./notehub/slack/webhook-url.png": 52072,
	"./notehub/support-invite-button.png": 45020,
	"./notehub/support-list.png": 70488,
	"./notehub/support-reason.png": 21956,
	"./notehub/url_variables.png": 35758,
	"./quickstart/checked-devices-screen.png": 59315,
	"./quickstart/devices-screen.png": 13815,
	"./quickstart/events-screen-2.png": 65878,
	"./quickstart/events-screen.png": 31394,
	"./quickstart/example-tutorial/picture1.png": 69538,
	"./quickstart/login-screen.jpg": 88478,
	"./quickstart/lora/devices-screen.png": 18495,
	"./quickstart/lora/event-screen.png": 19955,
	"./quickstart/lora/events-screen.png": 21755,
	"./quickstart/lora/projects-screen.png": 91233,
	"./quickstart/lora/serial-prompt.gif": 74501,
	"./quickstart/lora/view-device-notehub.png": 97297,
	"./quickstart/micro-usb-port.jpg": 9457,
	"./quickstart/notehub-projectuid.png": 99540,
	"./quickstart/opening-terminal.gif": 747,
	"./quickstart/projects-screen.png": 287,
	"./quickstart/pt2/checked-devices-screen.jpg": 81126,
	"./quickstart/pt2/devices-screen.jpg": 99737,
	"./quickstart/pt2/events-screen.jpg": 42845,
	"./quickstart/pt2/postman-1.png": 56904,
	"./quickstart/pt2/postman-2.png": 38507,
	"./quickstart/pt2/postman-3.png": 81453,
	"./quickstart/pt2/postman-4.png": 743,
	"./quickstart/pt2/postman-5.png": 2829,
	"./quickstart/pt2/postman-6.png": 89420,
	"./quickstart/pt2/postman-7.png": 97172,
	"./quickstart/pt2/postman-8.png": 78668,
	"./quickstart/pt2/send-data-screen.png": 38063,
	"./quickstart/repl-disconnect.gif": 12620,
	"./quickstart/send-data-screen.png": 75678,
	"./quickstart/serial-prompt.gif": 31106,
	"./quickstart/serial-prompt.png": 90276,
	"./quickstart/simulator.svg": 75884,
	"./quickstart/sparrow/architecture-overview.png": 93896,
	"./quickstart/sparrow/battery-backup.jpg": 94631,
	"./quickstart/sparrow/box-contents.jpg": 81218,
	"./quickstart/sparrow/card-wifi-example.png": 93455,
	"./quickstart/sparrow/connecting-a-usb-cable.jpg": 34116,
	"./quickstart/sparrow/connecting-notecarrier.jpg": 5990,
	"./quickstart/sparrow/dev-kit-architecture.png": 47872,
	"./quickstart/sparrow/disconnected-button.png": 45015,
	"./quickstart/sparrow/essentials-board-dip-switches.jpg": 79256,
	"./quickstart/sparrow/events-location.png": 21187,
	"./quickstart/sparrow/hardware.png": 30197,
	"./quickstart/sparrow/health-qo-event.png": 14298,
	"./quickstart/sparrow/hub-set-example.png": 41717,
	"./quickstart/sparrow/location-of-node-id.png": 22285,
	"./quickstart/sparrow/new-notehub-project.png": 42620,
	"./quickstart/sparrow/notecarrier-dip-switch.jpg": 46530,
	"./quickstart/sparrow/pairing-devices.jpg": 68431,
	"./quickstart/sparrow/product-uid.png": 94314,
	"./quickstart/sparrow/sensor-db-events.png": 91741,
	"./quickstart/sparrow/unscrew-enclosures.jpg": 45065,
	"./quickstart/starnote/starnote-flow.png": 99453,
	"./quickstart/starnote/starnote-ignion.png": 95220,
	"./quickstart/starnote/starnote-notecard-sync.png": 50890,
	"./quickstart/starnote/starnote-notehub.png": 82575,
	"./quickstart/starnote/starnote-ufl.png": 82096,
	"./quickstart/steps/app-step.png": 27874,
	"./quickstart/steps/blues-gateway.png": 92535,
	"./quickstart/steps/mcu-step.png": 95529,
	"./quickstart/steps/notecard-step.png": 50567,
	"./quickstart/steps/routing-step.svg": 50484,
	"./quickstart/swan/arduinoide-bsp-config.png": 70210,
	"./quickstart/swan/arduinoide-stm32-board-part.png": 22855,
	"./quickstart/swan/arduinoide-stm32-board.png": 55127,
	"./quickstart/swan/cp-buttons.png": 23070,
	"./quickstart/swan/stmcubeide-board-select.png": 85125,
	"./quickstart/swan/stmcubeprogrammer-reg-menu.png": 26795,
	"./quickstart/swan/swan-bootloader.png": 26263,
	"./quickstart/swan/swan-circuitpython.png": 92046,
	"./quickstart/swan/swan-debug-breakpoint.png": 79794,
	"./quickstart/swan/swan-debug-output.png": 29463,
	"./quickstart/swan/swan-lipo-usb.jpg": 82898,
	"./quickstart/swan/swan-micro-usb.jpg": 82936,
	"./quickstart/swan/swan-stlink.jpg": 69834,
	"./quickstart/swan/vscode-arduino-board-config-options.png": 29165,
	"./quickstart/swan/vscode-arduino-done-uploading.png": 32339,
	"./quickstart/swan/vscode-arduino-examples.png": 36778,
	"./quickstart/swan/vscode-arduino-extension.png": 67856,
	"./quickstart/swan/vscode-arduino-launch-json-bug-workaround.png": 99259,
	"./quickstart/swan/vscode-arduino-launch-json-bug.png": 20314,
	"./quickstart/swan/vscode-arduino-open-board-dialogue.png": 42127,
	"./quickstart/swan/vscode-arduino-upload-button.png": 50807,
	"./quickstart/swan/vscode-platformio-extension.png": 73869,
	"./quickstart/swan/vscode-platformio-new-project.png": 27125,
	"./quickstart/swan/vscode-platformio-serial-monitor.png": 81487,
	"./quickstart/swan/vscode-platformio-wizard.png": 87480,
	"./quickstart/swan/vscode-select-blink.png": 24163,
	"./quickstart/view-device-notehub.png": 98372,
	"./reference/notecard-api/api.png": 95784,
	"./reference/notecard-api/inbound.gif": 25488,
	"./reference/notecard-api/inbound_noloop.gif": 61948,
	"./reference/notecard-api/outbound.gif": 64232,
	"./reference/notecard-api/outbound_noloop.gif": 68017,
	"./reference/notecard-api/overview.png": 84026,
	"./reference/notecard-api/proxy-route-event-details.png": 51200,
	"./reference/notecard-api/proxy-route-event.png": 66436,
	"./reference/notecard-api/proxy-route.png": 25839,
	"./reference/notehub-qi.png": 63173,
	"./reference/notehub-qis.png": 53943,
	"./sparrow/builders-guide/bug-icon.png": 50277,
	"./sparrow/builders-guide/container-icon.png": 13412,
	"./sparrow/builders-guide/container-menu.png": 2562,
	"./sparrow/builders-guide/hammer-icon.png": 7426,
	"./sparrow/builders-guide/play-icon.png": 70801,
	"./sparrow/builders-guide/run-configurations.png": 83191,
	"./sparrow/builders-guide/stm32-loading-project.gif": 75157,
	"./sparrow/builders-guide/terminal-configuration.png": 65683,
	"./sparrow/builders-guide/vs-code-debugging.png": 50466,
	"./sparrow/data/air-qo-event.png": 11849,
	"./sparrow/data/jsonata-example.png": 84370,
	"./sparrow/data/sparrow-reference-web-app.png": 78098,
	"./sparrow/firmware-updates/browse-button.png": 46338,
	"./sparrow/firmware-updates/connect-button.png": 4198,
	"./sparrow/firmware-updates/erasing-and-programming.png": 52920,
	"./sparrow/firmware-updates/example-elf-location.png": 23734,
	"./sparrow/firmware-updates/hardware-reset.png": 68245,
	"./sparrow/firmware-updates/start-programming.png": 98855,
	"./sparrow/firmware-updates/stlink-connection.jpg": 36487,
	"./sparrow/firmware-updates/stm-connection-type.png": 74332,
	"./support/premium_support.svg": 18425,
	"./support/status.svg": 24934,
	"./tools-and-sdks/arduino-api/examples.gif": 25676,
	"./tools-and-sdks/arduino-api/platformio-1.png": 89234,
	"./tools-and-sdks/arduino-api/platformio-2.png": 70550,
	"./tools-and-sdks/arduino-api/platformio-project.png": 21716,
	"./tools-and-sdks/firmware-libraries.png": 47987,
	"./tools-and-sdks/host-mcu-samples.png": 50045,
	"./tools-and-sdks/notecard-cli/cli-all.png": 56800,
	"./tools-and-sdks/notecard-cli/cli-info.png": 79479,
	"./tools-and-sdks/notecard-cli/cli-play.png": 51676,
	"./tools-and-sdks/notecard_cli.svg": 34369,
	"./tools-and-sdks/notehub-js.webp": 83049
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79424;